export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "World Gymnastics Yearbook 2025",
  "shortTitle": "",
  "description": "",
  "width": 620,
  "height": 877,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "/2025", 
  // "basePath": "", 
  "companyLogo": "1-logo-1.png",
  "publishURL": "",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "subscribeEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/2025/static/_content/world-gymnastics-yearbook-2025.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true,
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true,
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {

      '16-1.jpg':'Gymnastics for All requires clubs and groups to think outside the traditional confines of the sport, which opens the way for creative, eye-catching ways to showcase skills. The group from Portugal’s Associação Grupo de Ginástica de Vouzela has clearly understood the assignment.',
      '16-2.jpg':'Gymnastics is a zero-limit sport, which extends into age and ability. Whether nine months or 90 years old, there’s a place for the willing. Australia’s Woden Valley Groove and Move team was all smiles as it performed at the World Gym for Life Challenge in Lisbon (POR) in July.',
      '16-3.jpg':'Having no restrictions on the number of team members and no requirements allows creativity to flourish at the World Gym for Life Challenge. In their eye-catching performance, Germany’s Röhlingen Gold Seekers have opted for a combination of Acrobatics and TeamGym.',
      '16-4.jpg':'A longtime attendee of Gymnastics for All events, Japan’s University of Tsukuba is known for its colourful routines, often done with large props. This latest creation, delivered with infectious enthusiasm, wowed the Lisbon crowd.',
      '16-5.jpg':'Inclusion underpins the framework of Gymnastics for All, where everyone is welcome and all contribute to group performances.',
      '16-6.jpg':'Few nations combine theatre and Gymnastics for All as well as Italy, where the lines between art and sport often blur. A good representative of this concept is La Trottola Gymnastics club, where every aspect of performance from costuming to choreography is clearly relished.',
      '16-7.jpg':'Friendship, along with fun, fitness and fundamentals, is a major part of the ethos of Gymnastics for all. The concept that these tenets stretch forever, across lifetimes, is also important.',
      '16-8.jpg':'Formed in 2016 as a performance group that united gymnasts from different clubs, Switzerland’s Welsch Master Team rose to claim the Bruno Grandi Trophy at the World Gym for Life Challenge in Lisbon in July 2026.',
      '16-9.jpg':'The secret to sparkling performances? It’s all in the details for young gymnasts at the World Gym for Life Challenge.',
      '16-10.jpg':'Excitement bubbles over at the World Gym for Life Challenge as results are announced and gymnasts see how their hard work and preparation has paid off.',

      '22-1.jpg':'Maria Drobniak (POL) sails through a Yurchenko-style vault during women’s qualification at the Artistic Gymnastics World Championships in Jakarta (INA).',
      '22-2.jpg':'Flying Flavia Saraiva (BRA) shows why she’s a fan favourite on Floor Exercise. Self-described “famous in Brazil” after winning Olympic team bronze in Paris, Saraiva only returned to major competition just before the World Championships in Indonesia.',
      '22-3.jpg':'A World Championship held in southeast Asia provided a boost for athletes from the region, who delightedly showed up and showed out in Indonesia. Yeoh Li Wen (MAS) was among those who capitalised on the short travel distance.',
      '22-4.jpg':'Shhh! Olympian Natalia Escalera (MEX) wanted the crowd to hear her Bad Bunny Floor exercise music.',
      '22-5.jpg':'At the World Championships for the first time ever, Cameroonian gymnasts like Lisa Mebar (CMR) lit up the Jakarta arena with big smiles and positivity, obviously delighted to be part of history for their nation.',
      '22-6.jpg':'Olympian Shin Solyi (KOR) led a focused Korean effort on Balance Beam.',
      '22-7.jpg':'World Championships debutant Leila Vasileva (AIN) sat through some nervous moments awaiting her scores in Jakarta before finishing sixth on Uneven Bars.',
      '22-8.jpg':'A happy Kate McDonald (AUS) accepts congratulations from a teammate after a successful Uneven Bars routine in Jakarta. McDonald finished fifth on bars in her first World Championships final.',
      '22-9.jpg':'Already an Olympian and Southeast Asian Games champion, Aleah Finnegan (PHI) had plenty to cheer about as she turned in another standout performance on the world stage.',
      '22-10.jpg':'The first World Championship after an Olympic break is a time for new faces to come to the forefront. One of the most intriguing to appear was 15-year-old Sophia Weisberg (BRA), who won the Brazilian Championship in 2025 and whose graceful performances in Jakarta were the subject of much attention and admiration. A story to be continued…',

      '24-1.jpg':'European champion Adem Asil (TUR) projects his ranking as he is introduced for the Still Rings final at the Artistic Gymnastics World Championships. The confident Turkish gymnast, a World champion on the apparatus in 2022, finished with silver this time.',
      '24-2.jpg':'Two-time Olympic champion Zou Jingyuan (CHN) is still hungry for accomplishments. Following a post-Olympic break, the 27-year-old returned to prove that he is untouchable on Parallel Bars by quite some way. In Jakarta Zou defeated his nearest rival by almost a full point for his fourth World title on the apparatus.',
      '24-3.jpg':'A year removed from his double Olympic triumph in Paris, all eyes were on Carlos Yulo (PHI) at the first World Championships held in his home region. With silver on Floor Exercise and gold after a magnificent stuck piked Dragulescu, Yulo proved once more just what he’s capable of, much to his delight.',
      '24-4.jpg':'Full of intensity, Donnell Whittenburg (USA) came to the World Championships filled with purpose. His persistence and resilience paid off handsomely, with Whittenburg clinching gold on Still Rings, his first World Championships medal in a decade and first gold coming at age 31.',
      '24-5.jpg':'At the other end of the age spectrum, Hong Yanming (CHN) travelled to Jakarta as a little-known 19-year-old who showed signs of being a Pommel Horse prodigy. China’s youth champion on the apparatus just three years before, Hong jumped into the lead with a scintillating routine in his first World Championships final and never relinquished it, becoming the youngest men’s champion crowned in Indonesia.',
      '24-6.jpg':'The 2025 World Championships in Indonesia were the first held in southeast Asia, and Indonesian teams proudly donned their national colours for the momentous occasion. Among them, Satria Tri Wira Yudha (INA) embraced the opportunity to perform on Parallel Bars. Indonesian coaches believe Jakarta was a stepping stone toward greater global glory.',
      '24-7.jpg':'Jake Jarman (GBR) initially shot to prominence for his daredevil antics on Floor Exercise, but he had never won a World medal on there until Jakarta, where the 23-year-old finally found the combination of skills that would bring him gold. Among those who pushed him was teammate Luke Whitehouse, the eventual silver medallist. Jarman acknowledged that just being one of the two British gymnasts to make the final felt like half the battle.',
      '24-8.jpg':'Unable to participate at the Paris Olympics, a delighted Caio Souza (BRA) relished every moment of his return to World Championships competition. A ninth place All-Around finish at his eighth World Championships and sixth on Still Rings were both personal bests for the 32-year-old.',
      '24-9.jpg':'Two years after a serious leg injury on a Horizontal Bar dismount, the taste of a second World title on the apparatus was oh-so-sweet for Brody Malone (USA).',
      '24-10.jpg':'Finishing just behind Carlos Yulo (PHI) in the Men’s Vault standings in Jakarta was hardly discouraging for 2022 World champion Artur Davtyan (ARM). Rather, it confirmed to the two-time Olympic medallist that he’s on the right path forward. Onward and upward for the 33-year-old.',

      '26-1.jpg':'A sign of things to come? Nishiyama Misa’s (JPN) elegance turned heads at the Junior World Championships in Manila in November. Calm and poised amidst a lot of difficulty, Nishiyama cemented herself as one of Japan’s biggest young hopes by winning the Junior World Floor title.',
      '26-2.jpg':'It’s been about a decade since a young genius emerged from the east. With several scores that would have put him in contention for medals at the senior World Championships, 17-year-old Arsenii Dukhno (AIN) proved he’s someone worth keeping an eye on in the years ahead.',
      '26-3.jpg':'Already crowned Junior European champion in 2024, Elena Colas (FRA) carried the weight of national as well as personal expectations at the Junior World Championships. As ever, the 15-year-old showed she was up to the task she’d set. Colas sizzled on the world stage, contributing half the routines as France claimed a historic team gold before returning to take All-Around silver.',
      '26-4.jpg':'Nao Ojima (JPN) sees no point in being shy about his goals; he hopes to be an Olympic champion one day. With four medals, including a shared gold on Parallel Bars and All-Around silver in Manila, Nao is well on his way.',
      '26-5.jpg':'Milana Kaiumova’s (AIN) radiated quiet confidence throughout the Junior World Championships, where the 15-year-old finished sixth All-Around. But it wasn’t until the Uneven Bars final where she finally stepped into her own spotlight, with great swing combined with intricate inbar stalders assured her the gold medal.',
      '26-6.jpg':'The Pommel Horse final in Manila was wild, but Zhang Ao (CHN) was cool under fire. Massive difficulty and exceptional delivery increased the 18-year-old’s chances for gold as many podium contenders came off during the apparatus final. When all was said and done, Zheng was alone at the top.',
      '26-7.jpg':'Bubbly Xiang Yina (CHN) kept things steady and serious on the apparatus as she became the second consecutive woman from China to win the Junior World title on Balance Beam. Blending stellar technique with piquant choreography, Xiang bounded ahead of the rest of the field. ',
      '26-8.jpg':'When it came to bidding for the Junior World title on Vault, Lavi Crain (USA) employed a bit of strategy: the 14-year-old watered back in the early sessions of the competition but threw her full difficulty in the final. Her double-twisting Yurchenko won the day in the apparatus final, giving Crain the U.S. women’s only title of the meet.',
      '26-9.jpg':'Already a social media star for the daredevil skills he shows in training, Camilo Vera (COL) stole the show on the final day of competition by winning two titles. Vera tied with Ojima Nao (JPN) on Parallel Bars and then presented a high-flying Horizontal Bar exercise featuring back-to-back Kovacs release skills, confirming that the Colombian team’s stock is shooting skyward. Vera is pictured with Horizontal Bar silver medallist Danila Leykin (USA) and bronze medallist Eldrew Yulo (PHI).',

      '32-1.jpg':'Reigning World and Olympic champions the People’s Republic of China came to the first Rhythmic World Championships after the Olympic break with new programmes and a refreshed look. We’re ready for this, their opening poses seemed to say. Magnificent with the 5 Ribbons, the Chinese scooped up the top prize with that apparatus, but wound up only fourth in the All-Around.',
      '32-2.jpg':'The master of expression in Rhythmic is Sofia Raffaeli (ITA), who is just as good at assuming a character as she is tossing and catching the apparatus. Her favourite routine this year was her Hoop exercise, set to an Italian song that evoked the black and white film era. The judges liked it just as much, making Raffaeli World Hoop champion for the second time.',
      '32-3.jpg':'Gymnasts from the Republic of Korea demonstrate flexibility and synchronicity, two of the tenets of Rhythmic Group Gymnastics.',
      '32-4.jpg':'For the first time, the Rhythmic Gymnastics World Championships were held in South America, and fans from around the region couldn’t get enough. The energy in the Rio de Janeiro arena reached fever pitch whenever Brazilian gymnasts were on the carpet, quieting only when gymnasts assumed their starting poses.',
      '32-5.jpg':'An Olympian with the Brazilian Group in 2020, Geovanna Santos (BRA) has since gone out on her own and risen to become one of Brazil’s most successful and popular gymnasts. Emotive and energetic, Santos proved was one of the main attractions for Brazil fans at the World Championships.',
      '32-6.jpg':'A record 76 nations registered to participate at the first Rhythmic World Championships held in South America, including six that had never taken part before and several others who rarely appeared – among them, this graceful Group from Kyrgyzstan.',
      '32-7.jpg':'Celebrating her 20th birthday, fan favourite Stiliana Nikolova (BUL) earned a career-high five medals, including All-Around silver. It was redemption for the Paris Olympics, where the Bulgarian sensation finished just outside the cut of gymnasts who made the All-Around final.',
      '32-8.jpg':'Gymnasts of all ages and abilities took centre stage during the Closing Ceremony gala, a traditional facet of World Championship competition in Rhythmic Gymnastics.',
      '32-9.jpg':'After not qualifying to the Olympic Games in 2024, the Japanese Group experienced an extraordinary reversal of fortune at the Rio de Janeiro World Championships when their showstopping performance with the Hoops and Balls edged Brazil for All-Around gold. Team members’ faces at the end of the routine convey emotions a range of emotions between disbelief to delight.',

      '34-1.jpg':'Teamwork made the dream work for the Ukrainian Group at the Junior World Championships in Sofia (BUL). Possessed of a strong heritage in Rhythmic, Ukraine won gold for its 5 Clubs competition as well as All-Around bronze for a package of routines, including this one with the Hoops.',
      '34-2.jpg':'By making her apparatus look like an extension of her body, Wang Qi (CHN) demonstrates one of the major goals of a rhythmic gymnast. This majestic performance with the Ball earned Wang the silver medal — and caught the Rhythmic Gymnastics world’s attention.',
      '34-3.jpg':'Unbridled delight when a routine goes right! Magdalena Valkova (BUL) and her coach celebrate Valkova’s gorgeous performance with the Hoop. Valkova won the apparatus, giving her and Bulgaria the first gold of the championships.',
      '34-4.jpg':'The success of new and diverse nations was the biggest story at the Rhythmic Junior World Championships in Bulgaria, which saw gymnasts like Zlata Arkatova flourish. The gold medallist with the Clubs, Arkatova is the first Junior World Championships medallist from Kyrgyzstan in Gymnastics.',
      '34-5.jpg':'Mascots, still a relatively new feature in major international competitions, orchestrated well-timed moments of celebration in Sofia. This one throws streamers during the victory ceremony for the Ball competition, much to the delight of gold medallist Akmaral Yerekesheva (KAZ), silver medallist Wang Qi (CHN), and bronze medallist Nita Jamagidze (GEO).',
      '34-6.jpg':'A powerful contender for decades in Rhythmic Gymnastics, Bulgaria celebrated renewed success with its newest Group, which won the Junior World title in 2025, heading off strong challenges from Brazil, Ukraine and Italy.',

      '38-1.jpg':'An instant of softness and synchronicity of a mid-routine moment in flight is provided here by veteran Synchronised Trampoline pair Camilla Gomes and Alice Gomes (BRA). The 2025 World Championships in Pamplona (ESP) were Camilla Gomes’s 10th and Alice Gomes’s seventh.',
      '38-2.jpg':'The calm before the Tumbling: eyes firmly shut, Hippolyte Hergue (FRA) visualises the complex skills to come.',
      '38-3.jpg':'Ethan McGuinness (AUS) struggled massively leading up to the 2025 World Championships and might have withdrawn but for the fact that his family had already bought their tickets to Spain. McGuiness couldn’t have known that landing this pass would bring him his second World title in four years.',
      '38-4.jpg':'World Championships debutant Edith Penman (AUS) keeps things under control close to the ground mid-Tumbling pass.',
      '38-5.jpg':'Hugs for a job well done! This moment of coach-athlete camaraderie is brought to you by Mikey Barnes and Naana Oppon (GBR). The British women landed team Tumbling silver in Pamplona.',
      '38-6.jpg':'It was all good vibes for Women’s Synchronised Pair Tanaka Saki and Mori Hikaru (JPN), who topped the standings in Pamplona. A generation apart, the duo overcame initial communication issues and now reign together as World champions.',
      '38-7.jpg':'A feeling that never gets old: Seasoned veteran Tia Taylor (USA) celebrates a successful Tumbling pass with her coach.',
      '38-8.jpg':'Two-time World champion Yan Langyu (CHN), center, and teammates celebrate the People’s Republic of China’s victory in the All-Around Team competition on the final day of the World Championships in Spain. Team captain Yan anchored the collective effort by nailing one of the hardest Trampoline routines in the world.',
      '38-9.jpg':'France’s Manon Morancais, Candy Briere-Vetillard, Maelie Abadie, and Maelle Dumitru-Marin raise the tricolour after going lights-out in the Women’s Team Tumbling final. France’s gold was its first in this event since 2021.',
      '38-10.jpg':'Amidst a topsy-turvy final, teenage prodigy Wang Zisai, silver medallist at Paris 2024, reacted exuberantly to clinching the World title.',

      '48-1.jpg':'French gymnasts Lea Labrousse and Clea Brousse are mirror images of each other during their Synchronised Trampoline routine at The World Games in Chengdu (CHN).',
      '48-2.jpg':'Ruben Padilla (USA) has won almost everything during a long stretch at the top of the Double Mini-Trampoline mountain, but The World Games title has proven elusive. A mistake on his opening pass in Chengdu put Padilla in such a deep hole that even sticking a miraculous quadruple back dismount in his second pass was not enough to put him through to the final. We may see him again in Germany in 2029.',
      '48-3.jpg':'In a Men’s Tumbling final for the ages, Tofig Aliyev (AZE) put it all on the line with his full-full-full, a triple-twisting triple back somersault that nobody has ever even attempted in competition. The jubilant Aliyev collected silver for the performance in his first World Games appearance.',
      '48-4.jpg':'There were plenty of big smiles before and after routines in Trampoline disciplines at The World Games. Even in the heat of competition, Double Mini Trampoline specialist Diogo Cabral (POR) couldn’t keep the grin off his face.',
      '48-5.jpg':'Megan Kealy’s (GBR) initial reluctance to try out for the British team for The World Games eventually gave way to delight as she tumbled her way to gold. That didn’t mean there weren’t some nervous moments waiting for her scores, however.',
      '48-6.jpg':'Longtime Synchronised Trampoline partners Sophiane Methot, left, and Sarah Milette (CAN) could be satisfied with how their competition unfolded in Chengdu: the veteran Canadians outscored Commonwealth rivals Great Britain to climb onto the podium at The World Games.',
      '48-7.jpg':'A solid and difficult pass in the semifinal put Grace Harder (USA) into contention for Double Mini-Trampoline gold at her maiden World Games. The U.S. star settled for silver.',
      '48-8.jpg':'Melania Rodriguez (ESP) tried two triple pike somersaults over the course of the Women’s Double Mini Trampoline competition at The World Games. She missed her first (and with it the chance at the gold medal) but nailed her second to win the bronze. Landing the triple pike alone puts Rodriguez among the sport’s legends, a cause for huge celebration in and of itself.',
      '48-9.jpg':'Steady from start to finish, European champion Diana Gago (POR) brought Portugal The World Games title on Double Mini-Trampoline. Gago proved the most consistent gymnast of the top four, and the only competitor not to make a major error on one of her passes.',

      '50-1.jpg':'Best friends and longtime Acrobatics partners Murad Rafiyev (twisting) and Daniel Abbasov (AZE) won two World titles in 2024. They hoped for another gold at the World Games in Chengdu (CHN), but despite a polished performance landed in fourth place in a closely contested Men’s Pair final.',
      '50-2.jpg':'In 2024, Ding Wenyan, Gu Quanjia, and Ma Yixing (CHN) became the first Chinese Women’s Group in 30 years to win the World title. More history awaited at home: the dainty and daring trio performed flawlessly before an adoring home crowd, dazzling them with traditional touches in between intricate acrobatic sequences.',
      '50-3.jpg':'They waited so long for this. Israel’s Men’s Group came from different athletic backgrounds and were united in their quest for a major title. After four years of waiting, the moment arrived in an unexpected place: China, the reigning world champions’ home turf. The Chinese men faltered in the final, while Rotem Amihai, Or Abraham, Lior Borodin, and Tomer Offir (ISR) seized their advantage – and the gold medal.',
      '50-4.jpg':'Katherine Borcherding (USA), right, won bronze at the 2022 World Games with a different Women’s Pair partner. A return to Acrobatics’ the biggest international stage at The World Games with Maya Lissenkova was as sweet as it could be for Borcherding, regardless of where they finished in the rankings.',
      '50-5.jpg':'Polished and precise, Caylei Caldwell, Olivia Green, and Rebecca Greenberg (USA) executed the routine of their lives in The World Games final to finish with silver, their biggest result coming on the highest stage of their international careers.',
      '50-6.jpg':'A proud showing from Men’s Group members Abdulla Al-Mashaykhi, Seymur Jafarov, Riad Safarov, and Rasul Seyidli (AZE) saw flier Seyidli soaring through the World Games in Chengdu. Azerbaijan’s still new Men’s Group finished fourth in the competition.',
      '50-7.jpg':'Upset for gold at the World Championships in 2024, Yevfrosyniia Kryvytska and Ivan Labunets (UKR) channelled all their effort into winning The World Games title. That didn’t mean that the legendary duo didn’t have to endure nervous moments waiting for their scores at The World Games. It all turned out well for the renowned Ukrainians, who earned the Mixed Pairs gold they coveted.',
      '50-8.jpg':'Following a closely contested final, teenaged Mixed Pair Lara Fernandes and Guilherme Henriques (POR) celebrated a hit routine at The World Games. The duo, who have competed together for years, saw their hard work compensated with a silver medal.',
      '50-9.jpg':'Juan Daniel Molina and Jose Moreno (ESP) saw their wildest dreams become reality at The World Games, where they captured gold in an intensely competitive Men’s Pair final. The Spaniards performed first in the order, then sat and waited for one of their competitors to better their score. None did, fulfilling their coach’s pre-competition prophecy that the gold medal would be theirs.',

      '52-1.jpg':'Anastasiia Kurashivili and Stanislav Halaida (UKR) soared to their nation’s first Aerobic medal at The World Games with Mixed Pairs bronze. Kurashvili, already a World and European champion in her own right, and longtime partner Halaida went on to capture the European title in November.',
      '52-2.jpg':'In taking the World Trio title in 2024, Zhang Qingzhou and Wang Zhenhao (CHN) forged a reputation as the discipline’s showmen, unafraid of fun or flight in their performances. New team member Fan Siwei fit right in: at The World Games in Chengdu, the Chinese once more finished atop the rankings.',
      '52-3.jpg':'World champions several times over in their own right, childhood friends Kitazume Riri and Saito Mizuki (JPN) decided they wanted to end their careers together. They eschewed individual training in 2025 and put everything into their Mixed Pairs routine for Chengdu. In an emotional swansong, their efforts were crowned with gold.',
      '52-4.jpg':'There was a quiet but confident entry for China’s Aerobic Dance team as it prepared to compete at The World Games. The eight-person team earned bronze, the cherry atop the sundae after China’s titles in Trio and Group.',
      '52-5.jpg':'From Australia with attitude: The Australian Aerobic Dance team emanated energy in a breakout performance that had the Dong’an Lake Sports Park arena rollicking at The World Games.',
      '52-6.jpg':'In a discipline known for its pumping techno music and fast-paced dance steps, Madina Mustafayeva and Vladimir Dolmatov (AZE) poured effort into showcasing Aerobics’ softer side.',
      '52-7.jpg':'Intriguing shapes colour Aerobic Trio competitions. Veterans Davide Nacci, Francesco Sebastio, and Sara Cutini’s (ITA) inventive collaborations set them apart and helped them clinch silver in Chengdu.',
      '52-8.jpg':'Aerobics airtime: Mixed Pair Mara Dragomir and Madalin Boldea (ROU) take flight mid-routine.',
      '52-9.jpg':'World champion Hungary came to The World Games with a new routine built around a chess theme. The gambit worked brilliantly: Hungary’s sharp delivery checkmated its rivals in the final, sending scenes of celebration across the Aerobics world.',

      '54-1.jpg':'The skyscrapers of urban Chengdu provided a picturesque backdrop for Parkour practitioners at The World Games, including veteran Yaroslav Chum (CZE). Chengdu was Parkour’s second time on The World Games programme following a brilliant debut in 2022.',
      '54-2.jpg':'An outdoor venue meant athletes faced the humid outdoor summer weather head on at The World Games in China. Competitors including World champion Caryl Cordt-Moeller (SUI), left, wasted no time cooling themselves off after their runs.',
      '54-3.jpg':'The obstacle course-like nature of the Parkour setup made head-to-head speed races like this one between Andres Fierro (MEX) and Esteban Malaga (SVK) all the more exciting.',
      '54-4.jpg':'Even mid-somersault, freestyle standout Eloan Hitz (FRA) somehow manages to look perfectly on trend.',
      '54-5.jpg':'Teenager Nagai Nene (JPN) was thrilled with her freestyle performance at The World Games, which resulted in a silver medal at her first World Games.',
      '54-6.jpg':'Tobias Kahofer (AUT) demonstrates the skill and technique employed by Parkour practitioners when moving around the urban environment.',
      '54-7.jpg':'Parkour practitioners, including Shea Rudolph (USA), centre, were never moving so fast that they forgot to enjoy the moment in China.',
      '54-8.jpg':'Contenders in the Women’s competition from five continents line up to be introduced at The World Games.',
      '54-9.jpg':'Reporters flocked to interview Shang Chunsong (CHN) following her gold medal performance in Women’s Freestyle at The World Games in Chengdu.',
      '54-10.jpg':'After a year dominated by injury and self-doubt, a glowing Miranda Tibbling (SWE) reconfirmed herself as the queen of the speed run at her second World Games in Chengdu. The title was Tibbling’s second World Games gold, a fitting epilogue to her brilliant 2022 performance.',

    },
    "fullscreenEnabled": true,
  },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "YEARBOOK  2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `

        <div class="contentLink" style="top:822px;left:25px;width:288px;height:18px">
          <a href="https://global.fujitsu/en-global" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:839px;left:25px;width:153px;height:18px">
          <a href="https://global.fujitsu/en-global" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      
        <div class="addContentLink" onclick="Publish.goToPage(4);" style="top: 186px;left: 63px;width: 334px;height: 12px;"></div>

        <div class="addContentLink" onclick="Publish.goToPage(6);" style="top: 212px;left: 63px;width: 334px;height: 20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(8);" style="top: 232px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(9);" style="top: 244px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(10);" style="top: 256px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(11);" style="top: 268px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(12);" style="top: 281px;left: 63px;width: 334px;height: 12px;"></div>

        <div class="addContentLink" onclick="Publish.goToPage(14);" style="top: 308px;left: 63px;width: 334px;height: 20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(16);" style="top: 327px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(22);" style="top: 339px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(32);" style="top: 352px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(38);" style="top: 364px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(42);" style="top: 377px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(44);" style="top: 390px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(46);" style="top: 402px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(48);" style="top: 415px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(56);" style="top: 427px;left: 63px;width: 334px;height: 12px;"></div>

        <div class="addContentLink" onclick="Publish.goToPage(58);" style="top: 453px;left: 63px;width: 334px;height: 20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(60);" style="top: 472px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(62);" style="top: 485px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(64);" style="top: 497px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(66);" style="top: 510px;left: 63px;width: 334px;height: 12px;"></div>

        <div class="addContentLink" onclick="Publish.goToPage(68);" style="top: 536px;left: 63px;width: 334px;height: 20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(70);" style="top: 556px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(71);" style="top: 568px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(72);" style="top: 581px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(74);" style="top: 594px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(76);" style="top: 605px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(78);" style="top: 618px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(80);" style="top: 631px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(82);" style="top: 643px;left: 63px;width: 334px;height: 12px;"></div>

        <div class="addContentLink" onclick="Publish.goToPage(86);" style="top: 669px;left: 63px;width: 334px;height: 20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(88);" style="top: 689px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(89);" style="top: 701px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(90);" style="top: 713px;left: 63px;width: 334px;height: 12px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(91);" style="top: 727px;left: 63px;width: 334px;height: 12px;"></div>

        <div class="addContentLink" onclick="Publish.goToPage(92);" style="top: 757px;left: 63px;width: 334px;height: 20px;"></div>


        <div class="addContentLink" style="top: 512px;left: 424px;width: 88px;height: 13px;">
          <a href="https://www.gymnastics.sport" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "CONTENTS Introduction President’s foreword						  4  Highlights  6  Rebranding World Gym for Life Challenge World Championships Education The World Games  Sport		  Gymnastics for All Artistic Rhythmic Trampoline & Tumbling Acrobatics Aerobics Parkour The World Games Hear from the athletes  Media and Marketing Rebranding Fan engagement TV Fujitsu  Institutional  Transfer of Power Executive Committee and Council National federations Safeguarding Medical		 Education Academies Finance  Outlook  Non-World Gymnastics events World Championships 2026 Dakar 2026 World Gymnaestrada 2027  News in brief  8 9 10 11 12  14  16 22 32 38 42 44 46 48 56  58  60 62 64 66  68  70 71 72 74 76 78 80 82  86  88 89 90 91  92  World Gymnastics is the new brand introduced by the FIG to modernise and strengthen the sport's public image. It serves as the primary identity through which we communicate with fans, athletes, partners and the wider public. For the time being, the FIG remains the official legal entity, responsible for statutory and regulatory matters. In line with our new brand, the 2025 Yearbook is presented under the World Gymnastics identity. However, as the content reflects the 2025 season, events and documents are referenced accordingly.  Fédération Internationale de Gymnastique, Av. de la Gare 12 A, 1001 Lausanne, Switzerland Tel +41 (0)21 321 55 10 www.gymnastics.sport This publication may not be reproduced, even in part, in any form, without the written permission of the FIG. Production: Touchline Photography: AGF/Azerbaijan Gymnastics Federation; BRGF/Anna Nedkova; DTB/Thomas Rösler; Egyptian Gymnastics Federation; Filippo Tomasi; Gymnastics Australia; Hélder Cruz/ Gymnastics Federation of Portugal; Hungarian Gymnastics Federation; Jean-Pierre Limery; Laureus World Sports Awards; Ricardo Bufolin; Shutterstock; Simone Ferraro; Volker Minkus Printed by Pureprint. ISSN: 2813-9585  The World Gymnastics Yearbook is printed at a carbon-neutral printer, on a 100% recycled and carbon-balanced paper stock.  WORLD GYMNASTICS YEARBOOK 2025  03"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Introduction  President's foreword  President's foreword Morinari Watanabe World Gymnastics President IOC Member ASOIF Council Member  2  025 was a year defined by innovation, global growth and unity: historic championships across continents, bold new event formats and the launch of the World Gymnastics brand marked a dynamic new cycle for the global gymnastics family. This year has been marked by ambition, innovation and meaningful progress across all disciplines. Starting with Gymnastics for All, the World Gym for Life Challenge in Portugal was a resounding success, generating exceptional enthusiasm and engagement. In Rhythmic Gymnastics, the World Championships were hosted in Brazil, marking a historic first for South America. With a record number of participating nations, the event played a key role in advancing the development of gymnastics across the continent. Artistic Gymnastics held its World Championships in south-east Asia for the first time, in Indonesia. This milestone event, once again marked by unprecedented participation, significantly strengthened the growth of gymnastics in the region. It was regrettable that not all national federations were able to attend. We must continue to uphold the independence of our sport from political influence, and our organisation, together with the global gymnastics family, remains committed to supporting all athletes worldwide. Trampoline Gymnastics embraced a bold new direction by exploring the intersection of sport and entertainment through a uniquely show-focused World Championships in Spain. The various Junior World Championships demonstrated a balance of tradition and innovation.  04 WORLD GYMNASTICS YEARBOOK 2025  Young athletes in Trampoline Gymnastics competed in Spain, Rhythmic Gymnastics returned to Bulgaria and Artistic Gymnastics was staged in the Philippines, a nation strongly committed to the promotion of our sport. All three events welcomed a record number of participating nations. Notably, the Artistic Gymnastics Junior World Championships were held in a hotel ballroom for the first time. Despite initial concerns, this new format proved highly successful, reminding us of the importance of challenging established conventions. The technical level displayed by junior athletes across all disciplines surpassed expectations, and their future progress is eagerly anticipated. In the new cycle, Acrobatic Gymnastics, Aerobic Gymnastics and Parkour have each undertaken important initiatives, laying the foundation for significant growth in the years ahead. Towards the end of the year, many of our officials attended a Pilates event in Türkiye, reaffirming the need for a global gymnastics convention. At the same time, our federation reflected on its traditionally conservative structure and has since begun a transformation toward a more open, sustainable organisation with a long-term vision. In early December, the launch of the FIG’s new brand, World Gymnastics, marked another important milestone. Gymnastics is clearly gaining increased attention and recognition worldwide. Turning our attention to the year ahead, 2026 is the Year of the Horse in the lunar calendar, symbolising passion, momentum and opportunities for major progress. Let us ride forward together and make a great leap as one global gymnastics family."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Ofﬁcial Partners  World Gymnastics is proud to present its Official Partners, who not only support the organisation financially and in kind, but understand gymnastics and the importance of its efforts to promote the development of all disciplines. Our Official Partners help to make our World Championships and the World Gymnaestrada a great success and continuously support our member federations. We thank them for their dedication and ask the gymnastics community to return the favour by supporting the companies that advance the spirit of our disciplines."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "HIGHLIGHTS"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Highlights  Rebranding  HIGHLIGHTS REBRANDING  Introducing World Gymnastics Following extensive consultation with member federations, fans and global partners, World Gymnastics is now the new brand of the Fédération Internationale de Gymnastique (FIG). This brand introduces a new visual identity and will support the federation’s mission to promote the sport at every level around the world, from grassroots to elite.  08  WORLD GYMNASTICS YEARBOOK 2025  Pictured The World Gymnastics logo"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "World Gym for Life Challenge  Highlights  WORLD GYM FOR LIFE CHALLENGE A successful return for the fifth edition of the event  After an eight-year absence, the World Gym for Life Challenge was welcomed back with great fanfare as it hosted the Gymnastics for All community in Lisbon, Portugal. More than 3,700 gymnasts represented their clubs across the five days, performing in front of a sold-out MEO Arena. The event took place under the patronage of UNESCO for the first time, underlining gymnastics’s global importance and marking a significant milestone in its history.  Pictured Participants gather in Lisbon  WORLD GYMNASTICS YEARBOOK 2025  09"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Highlights  World Championships  HIGHLIGHTS 10  WORLD CHAMPIONSHIPS Historic host nations open a new era  From Rhythmic in Rio to Trampoline in Spain, the 2025 World Championships showcased a vibrant year for gymnastics. Each delivered memorable moments at both senior and junior levels, underlining the sport’s global depth. First-time hosts Indonesia and Brazil, in Artistic and Rhythmic, brought fresh energy, highlighting the sport’s continued expansion and the growing prominence of emerging nations on the world stage.  WORLD GYMNASTICS YEARBOOK 2025  Pictured Brazil group in Rio"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Education  Highlights  EDUCATION  Supporting the next generation The Youth Athlete Development (YAD) project was a major focus of World Gymnastics’s education initiatives in 2025. The programme, hosted by national federations and supported by Olympic Solidarity, promoted the growth of young gymnasts and coaches across the globe.  Pictured YAD athletes in Guatemala  WORLD GYMNASTICS YEARBOOK 2025  11"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Highlights  The World Games  HIGHLIGHTS 12  THE WORLD GAMES Gymnastics wows in Chengdu  The 12th edition of The World Games saw four gymnastics disciplines on the programme, with Trampoline & Tumbling, Acrobatics, Aerobics and Parkour all thrilling onlooking crowds. A total of 19 events took place across the four disciplines, with host nation People’s Republic of China winning five of the gold medals on offer.  WORLD GYMNASTICS YEARBOOK 2025  Pictured The World Games in Chengdu"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "BUILT FOR GYMNASTICS  From grassroots clubs to elite competitions, we support gymnasts at every stage of their journey. And since gymnastics starts with the right equipment, we believe reliable, high-quality equipment should be accessible to everyone. Because performance should always be within reach."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "SPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      
        <div class="addContentLink" style="top: 728px;left:70px;width:131px;height:13px;">
          <a href="https://live.gymnastics.sport/news.php?idevent=17055" target="_blank"></a>
        </div>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:390px; left:35px;"
        onclick="pg16_gallery(0)"
        src="/2025/static/_content/btn-camera-white.png"
        />
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Sport | Gymnastics for All  Lisbon hosts a long-awaited return The successful return of the World Gym for Life Challenge after an eight-year absence was the highlight of the year in Gymnastics for All.  F  or the worldwide Gymnastics for All community, five days in Lisbon in July left the most vivid memories of 2025. More than 3,700 gymnasts from 140 clubs representing 31 countries and five continents came together for the fifth edition of an event that celebrates diversity, creativity and community. Held from 22-26 July at the MEO Arena, this was a welcome return for the World Gym for Life Challenge, following the cancellation of the 2021 edition – also planned for Lisbon – owing to the COVID-19 pandemic. At the opening ceremony, which followed a gymnasts’ parade to the arena, World Gymnastics President Morinari Watanabe said: “The last  16  WORLD GYMNASTICS YEARBOOK 2025  World Gym for Life Challenge was held in 2017 in Norway. We have waited for eight years. Patience leads to success. Here in Lisbon, we have the highest number of participating federations ever. We also have the largest number of groups ever. The highest number of participants ever. Our patience has brought us great success.”"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Gymnastics for All | Sport  WORLD GYMNASTICS YEARBOOK 2025  17"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      
        <div class="addContentLink" style="top:38px;left:385px;width:84px;height:117px;">
          <a href="https://www.gymnastics.sport/publicdir/gfaabstract/" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:38px;left:477px;width:84px;height:117px;">
          <a href="https://www.gymnastics.sport/publicdir/gfaebook2/" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Sport | Gymnastics for All  Germany, with 747 gymnasts, Portugal (717) and Greece (622), had the largest delegations, yet each participating country from Albania to Zimbabwe left their mark on an event open to participants of all ages, genders, backgrounds and skill levels. Perfectly underlining that ethos, group members from Australia’s Woden Valley Gymnastics had an average age of 73. From 23-25 July, each day was composed of show performances and contests. The latter comprised four categories: Gymnastics and dance for large groups and small groups, and Gymnastics on or with large apparatus for large groups and small groups. After performing, each group had the option of receiving feedback from the experts evaluating them. The final day, Saturday 26 July, began with morning workshops before the World Gym for Life Challenge Gala, which involved performances from all the gold award-winning groups in each category plus two wild cards chosen by the GfA Committee. One of them was  Pictured Participants in Lisbon  18  WORLD GYMNASTICS YEARBOOK 2025  Hot off the press In July, the GfA Committee launched the second volume of its Worldwide Experiences book. This digital book draws together stories from across the world about GfA, covering its historical development and its contribution to contemporary society. The book can be read on or downloaded from the World Gymnastics website together with other online books, including the Colloquium Book of Abstracts from Baku.  Tanzhaus Hohenems, a group from Austria containing gymnasts of mixed abilities. In front of a sold-out arena, Switzerland’s Welsch Master Team emerged as recipients of the Bruno Grandi Trophy, the prize awarded to the Gala winners, for a performance titled ‘Resurrection’ that used a 14m x 14m air floor that also incorporated mini air mats used to launch team members high into the air.  Looking ahead 2025 was the first year of a new cycle for the new GfA Committee, which will run through to 2028. Along with promoting greater participation from federations and gymnasts, the committee is keen to promote more scientific research into the benefits of lifelong participation in gymnastics."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" style="top:687px;left:343px;width:195px;height:19px;">
        <a href="https://www.ginastica.org/wg2027" target="_blank"></a>
      </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Sport | Gymnastics for All  UNESCO support – and why it matters For the first time, the World Gym for Life Challenge took place under the patronage of UNESCO, which commended World Gymnastics for organising an event “which promotes physical activity in an inclusive manner by bringing together people of all ages and cultural backgrounds”. UNESCO had previously awarded its patronage to the 2025 Gymnastics for All Colloquium, which took place in Baku (AZE). On the significance of this support, Rogerio Valerio, President of  World Gymnastics’s GfA Committee, explained: “UNESCO and the United Nations have a programme called Fit for Life that tries to improve people’s quality of life around the world. UNESCO has recognised that gymnastics, and especially Gymnastics For All, matches their goals on that level. That brings us a recognition that we’re doing the right thing and supports those countries and national federations that are developing their GFA programmes, helping them be able to show their governments and their partners that what they’re doing is recognised and supported by UNESCO”.  Pictured Tanzhaus Hohenems (AUT)  Colloquium explores social impact Baku, capital of Azerbaijan, was the host of the 2025 GfA Colloquium, which ran from 2-4 April and featured representatives from Fiji, Türkiye and Kenya (a newly affiliated World Gymnastics nation) for the first time. In all, 41 national federations came together for three days of presentations and discussions, with the social impact of GfA providing a central discussion point. “The impact on communities was highlighted with examples from around the world,” Valerio explained after a broad range of federations offered examples of how GfA touches the lives of people of all ages and abilities. So inspiring did it prove that plans were subsequently put in place to revisit the theme at the 2026 Colloquium.  20  WORLD GYMNASTICS YEARBOOK 2025  Other Colloquium highlights were the ‘GfA around the world’ sessions – a platform for countries to present their latest activities and upcoming projects – and discussions on sustainability and the inclusion of GfA on university curriculums, both key topics from the Colloquiums in 2023 and 2024.  Planning for 2027 World Gymnaestrada Work towards the next World Gymnaestrada is underway, with an information session held with prospective national federations. With the World Gym for Life Challenge concluded, preparations continue for the 18th World Gymnaestrada, which Lisbon will host from 11-17 July 2027. To find out more, visit page 91."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
      
        <div class="addContentLink" style="top: 826px;left: 343px;width: 79px;height: 18px;">
          <a href="https://baenfer.de" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Industriestraße 11, 34537 Bad Wildungen, Germany  baenfer.de  baenfersportmanufaktur"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="22-no" class="abs montAlternatesBd 22-no" style="top:648px;left:445px; font-size: 2.5em; color: #1d1a3a; padding: 0px; margin: 0px;"  data-number='{"to": 4}' ></h1>

        <a href="https://youtu.be/jYk2LsKlfRo?si=Y8kfYOIWppWAkyUg" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:305px;left:34px;" src="/2025/static/_content/btn-play-white.png">
        </a>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:250px; left:34px;"
        onclick="pg22_gallery(0)"
        src="/2025/static/_content/btn-camera-white.png"
        />

      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim.fromTo(cOf("22-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[0])}}, 1)
        }

        function onPageLeave() {
          pg22Anim.stop();
          resetNumbers('22-no')
        }
      `,
      "searchText": "Sport  Women's Artistic  Stars old and new illuminate Indonesia Arena The 53rd Artistic Gymnastics World Championships took place at the 16,500-capacity Indonesia Arena in Jakarta from 19-25 October 2025. The women’s competition featured a return to the podium for Angelina Melnikova (AIN) and another history-making victory for Algeria’s Kaylia Nemour.  I  n her first World Championships appearance in four years, Angelina Melnikova won the All-Around and Vault titles as well as silver on Uneven Bars. She overcame a fall on Balance Beam in the All-Around final and the challenge of trailing Leanne Wong (USA) going into her final event, the Floor Exercise. She did just enough in her Floor routine to finish ahead of Wong by a single tenth in a repeat of their duel at the Worlds in 2021. China’s Zhang Qingying took the bronze. A powerful Cheng vault had helped Melnikova claim her All-Around gold and secure her second gold on that same apparatus. The final gymnast to go, she delivered a composed Cheng  22  WORLD GYMNASTICS YEARBOOK 2025  and double-twisting Yurchenko to score 14.466. Silver went to Lia-Monica Fontaine, a World Championships debutante from Canada, while USA’s Joscelyn Roberson won bronze – redemption for a gymnast who injured herself vaulting at the World Championships in 2023. Nemour breaks new ground once more One year on from becoming Africa’s first Olympic champion in gymnastics, Kaylia Nemour became her continent’s first World champion on Uneven Bars. The Algerian took silver at the Worlds in 2023 but this time she dominated the event, winning the title with 15.566  4  gymnasts from Cameroon took part, marking the country's first appearance at the Worlds"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="23-no" class="abs montAlternatesBd 23-no" style="top:414px;left:459px; font-size: 2.5em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 12}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim.fromTo(cOf("23-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[0])}}, 1)
        }

        function onPageLeave() {
          pg23Anim.stop();
          resetNumbers('23-no')
        }
      `,
      "searchText": "Women's Artistic  Sport  Technology on trial  Pictured Main - Angelina Melnikova (AIN) Below - Kaylia Nemour (ALG) Below right Sugihara Aiko (JPN)  If ‘Move to Inspire’ was the tagline in Jakarta, the Worlds witnessed a move towards the future with the trial use of the Fujitsu Judge Support System (JSS) on a selected apparatus in both the Women’s and Men’s competitions. In the Men’s competition, the High Bar supervisor was able to check with the JSS for accuracy during the qualification round. “A big advance in fairness in scoring for the sport,” reported Andrew Tombs, President of the Men’s Artistic Technical Committee. In the Women’s competition, the Floor Exercise was chosen for the trial. “The feedback from the supervisor was very positive because on Floor the gymnasts are performing elements in different directions and the judges’ view is not always the best, but with four cameras around the floor, we are confident that they can capture the real evaluation of the element,” explained Donatella Sacchi, President of the Women’s Artistic Technical Committee. Read more about Fujitsu projects on page 66.  12  nations won medals in Jakarta across both Men's and Women's Artistic  points, more than a point ahead of Melnikova and bronze medallist Yang Fanyuwei (CHN). Having narrowly missed out on an All-Around medal, Nemour also picked up a silver medal on Balance Beam – an event won by 18-year-old Zhang, her first-ever gold at only her second World Championships. Sugihara crowns comeback with gold Arguably the most uplifting story from the women’s Worlds in Jakarta was the gold medal that Japan’s Sugihara Aiko won on Floor Exercise – along with a bronze on Balance Beam – a decade after her World Championships debut  and six years after her most recent appearance on this stage. Sugihara had already turned back the clock by winning the Asian AllAround title a full 10 years after she had first won it in 2015. In Jakarta she delivered a biographical Floor Exercise to George Gershwin’s ‘Rhapsody in Blue’, a routine telling the story of her early successes, later struggles and ultimate triumph. It earned her 13.833 points, which was enough to beat Ruby Evans and Abigail Martin, whose medals marked the first time Great Britain had two gymnasts on a Floor podium.  WORLD GYMNASTICS YEARBOOK 2025  23"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
      
        <a href="https://youtu.be/K6l81LLXpOI?si=5qtJGYkdmkqHn6rr" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:595px;left:34px;" src="/2025/static/_content/btn-play-white.png">
        </a>

      <!--Gallery-->
      <img
      class="abs halfScaleC halfpulse animatedpulse pointer"
      style="top:650px; left:33px;"
      onclick="pg24_gallery(0)"
      src="/2025/static/_content/btn-camera-white.png"
      />
      
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Sport  Men’s Artistic  Hashimoto completes hat-trick The anticipated close contest between Olympic champion Oka Shinnosuke and Hashimoto Daiki did not materialise in Indonesia. Hashimoto held his own, chased by perennial adversary Zhang Boheng.  J  apan’s Hashimoto Daiki became champion of the world again in Jakarta and in the process took his place alongside the legendary Uchimura Kohei as the only male gymnasts to have won three successive All-Around titles on the world stage. The Tokyo 2020 Olympic All-Around champion overcame a cast of familiar rivals, including reigning Olympic champion Oka Shinnosuke (JPN) and 2021 World champion Zhang Boheng (CHN). In the final on 22 October, Hashimoto was unstoppable, recording the highest scores on Floor Exercise  Pictured Main - Hashimoto Daiki (JPN) Above right - Carlos Yulo (PHI)  24  WORLD GYMNASTICS YEARBOOK 2025  and Vault before doing likewise on his final routine, Horizontal Bar, where his 14.700 score ensured victory by 0.798 over Zhang. Noe Seifert made history for Switzerland with bronze, becoming the country’s first gymnast in 75 years to earn a World Championships medal in the All-Around. It was Zhang’s second world All-Around silver and one of several successes for China, which topped the medal table. Two-time Olympic Parallel Bars champion Zou Jingyuan (CHN) gained his fourth world gold on that apparatus, ahead of Japanese  Athletes’ Representatives named Filipa Martins (POR) and Shek Wai Hung (HKG) were elected as the new Athletes’ Representatives for Women’s and Men’s Artistic during the World Championships in Jakarta."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Men’s Artistic  newcomer Tsunogai Tomoharu and Daniel Marinov (AIN). 19-year-old Hong Yanming (CHN) won on Pommel Horse, taking gold in a keenly contested final ahead of Armenian teenager Mamikon Khachatryan, who matched his silver at the European Championships, and the USA’s Patrick Hoopes.  Yulo also gained a Floor Exercise bronze in a final that finished with a British one-two courtesy of Jake Jarman and Luke Whitehouse. Aided by his exceptional twisting ability, Jarman’s difficulty score secured his first world title, while Whitehouse’s triple back somersault opener brought him silver at his first Worlds.  Apparatus specialists shine One notably encouraging aspect of the Worlds was the latest chapter of successes by apparatus specialists from smaller countries with less tradition of winning major prizes. The Vault final provided the perfect example with Armenia’s Artur Davtyan narrowly missing out on gold in an exciting contest with Olympic champion Carlos Yulo (PHI) – the latter finishing with a score of 14.866 to Davtyan’s 14.833. Yulo’s stuck piked Dragulescu first Vault set up his second world title four years after his first. It earned him an extra 0.4 in difficulty, while Davtyan, renowned for his execution, made up some of the difference with 0.1 bonuses for sticking both his landings to finish 0.034 shy of gold.  U.S. men hit the jackpot Finally, there were apparatus golds for two United States gymnasts – a first for the nation at a World Championships not held on their home turf. Donnell Whittenburg became the first U.S. man to win a world title on Still Rings and, at 31, provided a tale of perseverance as he relegated previous world champions Adem Asil (TUR), Lan Xingyu (CHN) and Eleftherios Petrounias (GRE) to silver, bronze and fifth place respectively. Afterwards, Whittenburg told teammate Brody Malone “tomorrow, it’s your turn”. Malone proved him right by capturing his second world title on Horizontal Bar, his first major individual honour since a serious leg injury in 2023.  Sport  Can you stick it? This was the first World Championships since the introduction of the stick bonus on landings, introduced this year as part of the new Code of Points. In the Men’s competition, bonuses were given for 96 clean landings across three apparatus, a positive step that was well received by the spectators in Jakarta, Andrew Tombs affirmed.  WORLD GYMNASTICS YEARBOOK 2025  25"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="26-no" class="abs montAlternatesBd 26-no" style="top:549px;left:240px; font-size: 2.5em; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 4}' ></h1>
        <h1 id="26-no" class="abs montAlternatesBd 26-no" style="top:637px;left:240px; font-size: 2.5em; color: #b4ce47; padding: 0px; margin: 0px;"  data-number='{"to": 10}' ></h1>

        <a href="https://www.youtube.com/watch?v=II4G9x0bopc" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:355px;left:430px;" src="/2025/static/_content/btn-play-white.png">
        </a>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:420px; left:430px;"
        onclick="pg26_gallery(0)"
        src="/2025/static/_content/btn-camera-white.png"
        />

      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim.fromTo(cOf("26-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[0])}}, 1)
          pg26Anim.fromTo(cOf("26-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[1])}}, "-=0.2")
        }

        function onPageLeave() {
          pg26Anim.stop();
          resetNumbers('26-no')
        }
      `,
      "searchText": "Sport  Artistic  Minamino and Dukhno take All-Around golds in Manila The third edition of the Artistic Gymnastics Junior World Championships ran from 20-24 November 2025 in Manila, Philippines.  F  or the second successive edition, Japan produced a Junior AllAround world champion. On this occasion Minamino Yume prevailed in the final with the help of a stellar Balance Beam routine. The 14-year-old ran a close race with Elena Colas (FRA) and her compatriot Nishiyama Misa. Like Minamino, Arsenii Dukhno (AIN) arrived at the Marriott Grand Ballroom in Pasay City as a virtual unknown. But he quickly made his potential clear by claiming the Junior Men’s All-Around title ahead of Ojima Nao (JPN) and Yang Lanbin (CHN). Dukhno earned the top scores on Floor Exercise, Pommel Horse and Parallel Bars in the AllAround final, and later captured gold in the apparatus final on Vault with a sizzling triple-twisting Yurchenko. In the Team competition, France’s Elena Colas, Lola Chassat and Maiana Prat prevailed ahead of Japan and the USA. The 2024 Junior European All-Around champion, Colas, contributed half of France’s winning total of 108.432 points. Meanwhile, Yang Lanbin, Wang Chengcheng and Zheng Ao led the People’s Republic of China to their first world Junior Men’s Team title, with Japan and USA completing the podium. Vera does the double for Colombia Already something of an Instagram star for videos of his extraordinary training sequences, Colombia’s Camilo Vera gained acclaim in Manila by winning golds on Parallel Bars and Horizontal Bar. He tied for the Parallel Bars title with Ojima and then delivered a fabulous finale on Horizontal Bar. Danila Leykin’s (USA) silver in that same final meant he returned home  26  WORLD GYMNASTICS YEARBOOK 2025  with three medals while Karl Eldrew Yulo (PHI) – younger brother of Olympic champion Carlos – claimed his second bronze of the championships. Last but not least… Elsewhere, Lavi Crain (USA) won on Vault, Milana Kaiumova (AIN) on Uneven Bars, Xiang Yina (CHN) on Balance Beam and Nishiyama (JPN) on floor in the Junior Women’s apparatus finals. China won golds on Men’s Floor Exercise and Pommel Horse, courtesy of Yang Lanbin and Zheng Ao, while Dante Reive (USA) earned the first world Junior gold by a U.S. man on Still Rings.  4  golds won by CHINA, the most of any nation  10  countries appeared on the podium  Pictured Minamino Yume (JPN)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `

        <h1 id="27-no" class="abs montAlternatesBd 27-no" style="top:673px;left:65px; font-size: 2.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 9}' ></h1>
        <img class="abs halfScaleC 27-quote" style="top:526px;left:19px;" src="/2025/static/_content/27-quote-1.png"/>

        <a href="https://www.youtube.com/watch?v=1O-ZroIuclI&list=PLNYqWWimiG-PvrCgak4QdOEoAE0GusnTx" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:585px;left:52px;" src="/2025/static/_content/btn-play-white.png">
        </a>

        <a href="https://www.youtube.com/watch?v=tFE2OyQa_48" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:195px;left:470px;" src="/2025/static/_content/btn-play-white.png">
        </a>
      
      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim.fromTo(cOf("27-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("27-no")[0])}}, 1)
          pg27Anim.fromTo(cOf("27-quote"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.1)
        }

        function onPageLeave() {
          pg27Anim.stop();
          resetNumbers("27-no");
        }
      `,
      "searchText": "Artistic  Sport  Manukyan makes his mark on World Cup The number of events rose from four to six and Armenia’s Hamlet Manukyan was among those to prosper.  T  he 2025 Artistic Gymnastics World Cup series ran from February to April and comprised six events, starting in Cottbus and concluding in Cairo. The breakout star of the men’s series was Junior world and European Pommel Horse champion Hamlet Manukyan (ARM), who excelled in his senior debut. He won consecutive golds in Osijek, Doha and Cairo to take the overall Pommel Horse title before becoming European champion. There was another Armenian success as Artur Davtyan triumphed on Vault, while Milad Karimi (KAZ) was the only gymnast to prevail in two events, winning on Floor Exercise and Horizontal Bar. Nikita Simonov (AZE) on Rings and Nazar Chepurnyi (UKR) on Parallel Bars collected the other titles. Slovenian pair shine In Women’s Artistic Gymnastics, Teja Belak on Vault and Lucija Hribar on Uneven Bars brought Slovenia half the honours in the World Cup series. Other winners were Greta Mayer (HUN)  World University Games RhineRuhr 2025 Fifteen countries took home at least one medal in Artistic Gymnastics at the FISU World University Games, starting with Japan, who topped the table with eight golds and 17 medals overall. Other countries to strike gold were the People’s Republic of China (three), Canada, Armenia and Great Britain (one each).  on Balance Beam and Pan American All-Around champion Jayla Hang (USA) on Floor Exercise.  Pictured Hamlet Manukyan (ARM)  WHAT THEY SAID Gymnasts from  9  countries (Algeria, Argentina, Bulgaria, Chinese Taipei, Croatia, Israel, Kazakhstan, Türkiye, Ukraine) won titles in the World Challenge Cup series  For newly transitioned senior gymnasts, the 2025 World Cups held particular importance as they provided valuable exposure to high-level international events, offering experience, confidence and competitive insight.”  The series has gone from four events to six, which is good for gymnasts as there's more opportunity to perform and to get experience.”  Donatella Sacchi  Andrew Tombs  President of the Women’s Artistic Technical Committee  President of the Men’s Artistic Technical Committee  WORLD GYMNASTICS YEARBOOK 2025  27"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `

        <img class="abs halfScaleC 28-quote" style="top:221px;left:364px;" src="/2025/static/_content/28-quote-1.png"/>

        <div class="addContentLink" style="top:220px;left:141px;width:92px;height:12px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4392260" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:236px;left:341px;width:74px;height:12px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4391208" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim.fromTo(cOf("28-quote"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "STA T  Sport  Artistic  E  PLAY OF  Reflections and innovations  President of the Women’s Artistic Technical Committee Donatella Sacchi reflects on the new Code of Points while Andrew Tombs, her new Men’s Artistic counterpart, underlines how technology can be channelled to improve fairness.  S  tability. That was the name of the game for the Women’s Artistic Technical Committee in 2025, according to its President, Donatella Sacchi. And that stability refers especially to the new Code of Points for 2025-28. “Not making critical changes provides opportunities for gymnasts to stay active longer,” she says, “and the average age is increasing.” There were some changes, such as refining how artistry is defined on Balance Beam and Floor Exercise, and adding new incentives for gymnasts to show two dramatically different vaults. “The artistry part is working well,” adds Sacchi, who considers that “our new challenge is to make our competitions more attractive.” Hence the ambition to add a mixed team final to the Artistic programme, with Sacchi explaining: “We’ll apply to stage this for the first time at the Youth Olympic Games Dakar 2026.” On the subject of technology, Andrew Tombs, Sacchi’s Men’s Artistic counterpart, highlights the progress towards “improving fairness in scoring.” He elaborates: “Technology will evolve, the Judges Support System [Fujitsu] will be available to support the D jury to validate the value of elements where performance expectations may not have been met. This development will give coaches and gymnasts confidence that scores are accurate and reduce delays to the competition.  28  WORLD GYMNASTICS YEARBOOK 2025  “The development of the ‘real-time capture of execution deductions’ will lead to greater transparency in the judging process and speed up the release of scores. Both of these developments have the potential to connect with spectators and TV viewers to demystify how judging works.” Finally, to return to the Code of Points, Tombs echoes Sacchi in his view of the reduction of elements from 10 to eight in Men’s Artistic, citing anecdotal evidence that it will persuade some gymnasts to continue to compete in the All-Around for longer. He believes, too, that the raised tariffs on some of the more spectacular elements, such as high-level flight elements, will encourage more exciting routines.  Pictured Zhang Qingying (CHN)  Our new challenge is to make our competitions more attractive.” Donatella Sacchi  President of the Women's Artistic Technical Committee"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `

        <div class="contentLink" style="top:835px;left:316px;width:202px;height:22px">
          <a href="https://www.spieth-gymnastics.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Jermain Grünberg (NED) ― Artistic Gymnastics European Championships Munich 2022  Follow us on Instagram!  REACH THE MAXIMUM  SPIETH Gymnastics GmbH I www.spieth-gymnastics.com"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `

        <div class="addContentLink" style="top:696px;left:51px;width:74px;height:12px;">
          <a href=" https://www.youtube.com/watch?v=ksOaoGxWBvg" target="_blank"></a>
        </div>
      
        <div class="addContentLink" style="top:732px;left:51px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=Tp6p5UCQn40" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:745px;left:51px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=DxpUJszeIWQ" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:755px;left:51px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=pbTnWr6IsVk" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:768px;left:51px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=fXiIwcyACvU" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:802px;left:51px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=zVlcq3IYV9w" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:696px;left:317px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=gsUMIEBTUOc" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:707px;left:317px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=uA4TG-l5-DE" target="_blank"></a>
        </div>
        
        <div class="addContentLink" style="top:743px;left:317px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=J-dj-7u68Nw" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:755px;left:317px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=RWHN0vNJY9Q" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:792px;left:317px;width:74px;height:12px;">
          <a href="https://www.youtube.com/watch?v=wK0DU0zTjcQ" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Sport  Artistic  New elements Men’s and Women’s Artistic welcomed 11 new elements to the Code of Points. WOMEN’S ADDITIONS  MEN’S ADDITIONS  The year’s first World Cup, in Cottbus (GER), witnessed Zhang Yihan (CHN) present a new variation on the classic Tkatchev, soaring over the bar in the stretched position, done from a clear hip circle. Also on Uneven Bars, at the third World Cup in Antalya (TUR), her compatriot Yang Fanyuwei delivered a routine including a rare full-twisting stretched position Jaeger release element. On the same apparatus, Okamura Mana (JPN) unveiled a daring new dismount, an el-grip swing to half turn to double pike salto backward. With a tucked double twist dismount on Balance Beam, Celeste Mordenti (LUX) earned recognition at the 2025 World Challenge Cup in Varna (BUL), while at the European Youth Olympic Festival in Osijek (CRO), France’s Maiana Prat produced an original Split ring leap with 360-degree turn on Floor. Last but not least, 14-year-old Minamino Yume (JPN) left the Junior Worlds with not just the All-Around title but her own element after catching a piked Jaeger with full twist release skill on Uneven Bars.  Stefano Patron (ITA) registered his second element with his Parallel Bars performance at the 2025 World Cup in Cottbus (GER). The intricate pirouetting skill comprises a swing backward with quarter turn hop to ¾ handstand on one rail in the reverse direction. The Doha World Cup (QAT) delivered two new skills: on Parallel Bars, James Hall (GBR) paraded a new element involving a 5/4 salto straddled with ½ turn to upper arms. On Pommel Horse, Jesse Moore (AUS) combined Saso Bertoncelj’s signature element (Kehr with 270-degree turn on one pommel from side to cross support) with Alberto Busnari’s (pommel circle straddle through handstand, 360-degree turn to flairs) to create something all his own. At the Paris World Challenge Cup, Hamlet Manukyan (ARM) devised a skill with a Bertoncelj done immediately into a skill named for teammate Artur Davtyan (reverse Stockli with 270-degree turn from two pommels to cross support on one pommel). Finally, at the 2025 Asian Championships in Jecheon (KOR), Mahdi Olfati (IRI) landed a Yurchenko full-twisting double back on Vault with a difficulty of 5.6, a landmark moment for himself and his nation.  Women’s Artistic Gymnastics  Men’s Artistic Gymnastics  Balance Beam  Parallel Bars  The Mordenti  C  (0.3)  D G G F  (0.4) (0.7) (0.7) (0.6)  E  (0.5)  Uneven Bars The Okamura The Yang The Zhang The Minamino  Floor Exercise The Prat		  30  Pictured Jesse Moore (AUS)  WORLD GYMNASTICS YEARBOOK 2025  The Patron 2 The Hall		  C E  (0.3) (0.5)  G F  (0.7) (0.6)  Pommel Horse The Moore The Manukyan  Vault The Olfati		  5.6"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": ``,
      "script": `

        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="32-no" class="abs montAlternatesBd 32-no" style="top:621px;left:240px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 76}' ></h1>
        <h1 id="32-no" class="abs montAlternatesBd 32-no" style="top:692px;left:240px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 7}' ></h1>

         <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:540px; left:215px;"
        onclick="pg32_gallery(0)"
        src="/2025/static/_content/btn-camera-black.png"
        />
      `,
      "script": `

        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim.fromTo(cOf("32-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[0])}}, 1)
          pg32Anim.fromTo(cOf("32-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[1])}}, 1.1)
        }

        function onPageLeave() {
          pg32Anim.stop();
          resetNumbers("32-no");
        }
      `,
      "searchText": "Sport  Rhythmic  Rio hosts Worlds to remember From 20-24 August 2025, Rio de Janeiro staged the Rhythmic Gymnastics World Championships – a championships that were groundbreaking, if dominated by a familiar figure.  T  he 41st Rhythmic Gymnastics World Championships in Rio de Janeiro offered an event filled with firsts. For the first time, a South American nation, Brazil, provided the stage. Thanks partly to the southern hemisphere location, gymnasts from 76 nations were there to take part – a huge rise from the previous record of 62 set in 2022 – while 10 countries had gymnasts on the podium, another first. Germany was the most successful nation, with six medals, thanks largely to the continued dominance of Darja Varfolomeev. She won four individual gold medals and a further gold with Germany in the Team competition, where qualification scores for both individuals and groups were combined. Anastasia Simakova played a part by taking the Hoop bronze. Varfolomeev began her individual medal haul by retaining her All-Around title on 22 August. Stiliana Nikolova (BUL) won silver on her 20th birthday, while 2022 world champion Sofia Raffaeli (ITA) claimed bronze. Two of Varfolomeev’s golds came on the final day of the championships on 24 August, when she triumphed with Clubs, achieving the day’s highest score (31.700) in the process, and with the Ribbon. Japan finished second in the medals table, thanks to gold and silver in the Group All-Around and 5 Ribbons competitions respectively.  32  WORLD GYMNASTICS YEARBOOK 2025  76  nations took part – a record total  7  newcomer nations: Aruba, Costa Rica, Ivory Coast, Paraguay, Peru, Syria and Tunisia  Italy and Ukraine ended joint third, with one gold and two bronzes each. Italy’s gold was for Sofia Raffaeli with the Hoop, while Ukraine’s gold came in the Group 3 Balls + 2 Hoops final. Bulgaria won five medals in total – four silver and one bronze. They took silver in the Team competition, sharing the podium with Germany and Ukraine, while all the other four came from Nikolova. Group rivalries yield fireworks The contest between the People’s Republic of China and Japan was a highlight of the Group competition. With Brazil topping the leaderboard after the first half of qualifications, Japan then produced the highest"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
      
        <a href="https://www.youtube.com/watch?v=PBeMb9o-V1U&list=PLNYqWWimiG-O9PfRWVTK0xP7dIn2_32QO" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:755px;left:-9px;" src="/2025/static/_content/btn-play-black.png">
        </a>

        <a href="https://www.youtube.com/watch?v=PONhJFavP5Q&list=PLNYqWWimiG-O9PfRWVTK0xP7dIn2_32QO" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:700px;left:-9px;" src="/2025/static/_content/btn-play-black.png">
        </a>
      
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Rhythmic  Sport  Carnival atmosphere There were times when the Barra Olympic Park, the venue for these World Championships, had the feel of one of Brazil’s vibrant football stadiums – not least for its cheering section for the host nation, complete with enormous flags. “They created such an incredible atmosphere,” said Darja Varfolomeev, while World  Pictured Main - Darja Varfolomeev (GER) Below right - Rin Keys (USA)  score (28.350) for their 3 Balls + 2 Hoops routine to overtake the hosts and win the All-Around gold. Spain’s group delivered two fine routines for bronze, bumping Olympic champion China down to fourth. China bounced back to win gold for their 5 Ribbons routine, pushing Japan and Spain into second and third respectively. Finally, in the very last event, Ukraine achieved the highest group score of the entire championships (28.650) with their 3 Balls + 2 Hoops to seize the title. Breaking new ground Brazil made history with its silver medal in the All-Around final – their first medal of any colour at a Rhythmic  Gymnastics President Morinari Watanabe attested that “the atmosphere in the arena reflected Brazil’s unique culture and love of dance – an ideal stage for Rhythmic. The athletes themselves have said they hope to return here for future championships. Truly, there can be no greater compliment.”  Vladinova gets the vote Neviana Vladinova (BUL) was elected by her peers as the Athletes’ Representative for Rhythmic Gymnastics. Vladinova claimed Team silver at the 2018 World Championships in Sofia (BUL) and individual bronze with the Ball in the 2017 edition. She will now serve as the representative for Rhythmic on the Athletes’ Commission.  Worlds – then followed it up by earning another silver in the 3 Balls + 2 Hoops final. USA achieved the same milestone courtesy of Rin Keys’s silver with the Ball. Romania’s Amalia Lica’s Clubs silver, meanwhile, was her country’s first world medal since 1992. Finally, 17-year-old Hatice Gokce Emir made history for Türkiye by becoming her nation’s first Rhythmic World Championships finalist, reaching both the Hoop and All-Around finals.  WORLD GYMNASTICS YEARBOOK 2025  33"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="34-no" class="abs montAlternatesBd 34-no" style="top:284px;left:427px; font-size: 2.5em; font-weight: 300; color: #b3cd46; padding: 0px; margin: 0px;"  data-number='{"to": 69}' ></h1>
        <h1 id="34-no" class="abs montAlternatesBd 34-no" style="top:359px;left:427px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 13}' ></h1>

        <a href="https://www.youtube.com/watch?v=Ti9NF7-jY2k" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:138px;left:438px;" src="/2025/static/_content/btn-play-black.png">
        </a>

        <a href="https://www.youtube.com/watch?v=UHdiQ45WVpQ" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:640px;left:315px;" src="/2025/static/_content/btn-play-black.png">
        </a>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:460px; left:40px;"
        onclick="pg34_gallery(0)"
        src="/2025/static/_content/btn-camera-black.png"
        />
      
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim.fromTo(cOf("34-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[0])}}, 1)
          pg34Anim.fromTo(cOf("34-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[1])}}, 1.1)
        }

        function onPageLeave() {
          pg34Anim.stop();
          resetNumbers("34-no");
        }
      `,
      "searchText": "Sport  Rhythmic  Sofia witnesses new wave of talent The third Rhythmic Gymnastics Junior World Championships took place at the Arena Sofia in Bulgaria from 18-22 June.  T  he 2025 Rhythmic Gymnastics Junior World Championships provided encouraging signs for the discipline with a record 69 nations taking part and gymnasts from more nations than ever before gaining a place on the podium. Top of the medal standings was hosts Bulgaria. They started the competition well, winning the first two titles, for Group All-Around and team. Bulgaria added a further two gold medals in apparatus finals courtesy of Magdalena Valkova for Hoop, and the group for their 5 Hoops routine. Two bronze medals – in the Group Clubs final and for Valkova with Ribbon – raised their tally to six.  Including her team gold, Valkova was one of two individuals who ended the championships with three medals. The other was Akmaral Yerekesheva from Kazakhstan. Yerekesheva qualified in first place to all three events that she competed in, and won golds for Ball and Ribbon plus a silver with Hoop, leaving Kazakhstan second on the medal table in the process. Ukraine finished third after claiming Group gold with 5 Clubs and bronze in the Group All-Around. Exciting range of newcomers Alongside Kazakhstan, other nations reaching the podium for the first time were Kyrgyzstan, Brazil, Egypt, the People's Republic of China, Estonia and Georgia. Indeed, the podium after the Ball final featured three such countries with the aforementioned Yerekeshava joined by Wang Qi (CHN) and Nita Jamagidze (GEO). Of those, Zlata Arkatova (KGZ) was the most successful, winning the Clubs title after qualifying in fifth place. She finished ahead of silver medallist Farida Bahnas of Egypt, a nation that celebrated a second silver through Lina Heleika’s Ribbon performance. As for Brazil, their group took two silvers (All-Around and 5 Hoops) while Estonia tied Italy for 5 Hoops bronze.  69  nations took part in Sofia, a record  13  nations won medals, a significant increase from the six at the inaugural 2019 edition and nine in 2023  Pictured Akmaral Yerekesheva (KAZ)  Recognition spread around Alternative prizes handed out in Sofia included the Group Fan Favourite Award won by Portugal, the Best Synchronised Team Award captured by Brazil and the New Stage Award taken by Latvia, competing with a group for the first time.  34  WORLD GYMNASTICS YEARBOOK 2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `

        <img class="abs halfScaleC 35-quote" style="top:289px;left:368px;" src="/2025/static/_content/35-quote-1.png"/>

        <a href="https://www.youtube.com/watch?v=vuwnthD8B08" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:265px;left:305px;" src="/2025/static/_content/btn-play-white.png">
        </a>

        <a href="https://www.youtube.com/watch?v=7IMTZZDKOZ0" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:612px;left:538px;" src="/2025/static/_content/btn-play-black.png">
        </a>

      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();
          pg35Anim.fromTo(cOf("35-quote"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
          pg35Anim.stop();
        }
      `,
      "searchText": "Rhythmic  Sport  Onofriichuk and China finish on top The 2025 World Cup season ran from April to July and featured four events together with two World Challenge Cups.  T  he year’s Rhythmic Gymnastics World Cup honours were taken by Ukraine’s Taisiia Onofriichuk and the People’s Republic of China group. Onofriichuk went straight to the top of the World Cup All-Around rankings after gold in the opening event in Sofia (BUL) on 4-6 April and followed that up with silver in Baku (AZE). With a bronze medal in the concluding event in Milan (ITA), Onofriichuk cemented first place in the table. She also ranked first for both Hoop and Ribbon, second with Clubs and third with Ball, making her the most successful individual Rhythmic gymnast of the 2025 season, having already earned the European All-Around title in June. Germany’s Darja Varfolomeev finished second in the All-Around rankings and in first place for both Ball and Clubs, a satisfying result given her focus on school exams. Stiliana Nikolova (BUL) ranked third in the All-Around and second with Ball while Italy’s Sofia Raffaeli finished fourth after winning the titles in Baku and Milan. China gleam again In 2024, China outlined their potential by finishing first, second and third in the World Cup rankings for All-Around, 5 Hoops, and 3 Ribbons + 2 Balls respectively. It was a sign of things to come, as they went on to become Paris 2024 Olympic champions. A year on, just two members of  Pictured Taisiia Onofriichuk (UKR)  their Olympic team remained in 20-year-olds Ding Xinyi and Wang Lanjing, yet the group still dominated the World Cup series, finishing first in all three ranking lists. Poland ranked second All-Around and with 5 Ribbons, and third with 3 Balls + 2 Hoops, while Japan was third All-Around and also ranked second in the 3 Balls + 2 Hoops event and third with 5 Ribbons. The groups from Bulgaria, Brazil and Spain, who won the All-Around titles in Baku, Milan and Sofia respectively, did not feature highly because they all competed in fewer than three World Cup events.  Rhythmic Gymnastics World Cups are the highest stage for gymnasts, from Olympians to new senior gymnasts, to come from all around the world and compete in preparation for World Championships.” Noha Abou Shabana President of the Rhythmic Technical Committee  Rhine-Ruhr 2025 offers another stage to shine Rhythmic Gymnastics featured at the FISU World University Games in Germany, where Alina Harnasko (AIN) won the Individual All-Around gold, with Takhmina Ikromova (UZB) and Fanni Pigniczki (HUN) joining her on the podium. Azerbaijan, Ukraine and Japan made up the top three in the Group All-Around.  WORLD GYMNASTICS YEARBOOK 2025  35"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:172px;left:50px;width:65px;height:18px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4529713" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:493px;left:496px;width:45px;height:11px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4384102" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:504px;left:435px;width:95px;height:11px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4384102" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Rhythmic  New element The Dragas was added to the Code of Points in 2025.  T  ara Dragas became the third Italian after Alexandra Agiurgiuculese and Sofia Raffaeli to have a skill named after her after she performed a new body difficulty element at the July 2025 World Cup in Milan (ITA). The move is a 360-degreeturning Arabesque, the back leg lifted to horizontal with the hand and the torso bent backwards to horizontal. The element was added to the historical list of all body difficulties named after gymnasts (Appendix 3 of the Code of Points) following the World Championships in Rio de Janeiro (BRA).  Pictured Tara Dragas (ITA)  STA T  Sport  E  PLAY OF  THE DRAGAS Arabesque: Free leg horizontal backward with help, and with horizontal backbend Element value: Base value of 0.4 for the 360 degree rotation. Each additional rotation will be awarded +0.2. Symbol:  President of the Rhythmic Technical Committee Noha Abou Shabana reflects on 2025 – and looks forward too. “Develop live judging and develop new countries.” For Noha Abou Shabana (EGY) those are two of the goals for her second cycle as President of World Gymnastics’s Rhythmic Gymnastics Technical Committee. Another goal is to have a final round added to the Rhythmic Gymnastics competition at the Olympic Games, though achieving that may be further away. Reflecting on the Code of Points for 2025-28, the removal of combined elements and the “possibility to perform more artistry” were well received this year, says Abou Shabana. “Many gymnasts stayed from the last cycle to this cycle, so the age has increased,” she adds. To develop the sport, there will be a focus on Oceania in this cycle along with efforts to restore the discipline to events such as the Mediterranean Games. Finally, athlete well-being remains paramount and 2025 saw a webinar for gymnasts with Safeguarding Commission President Donatella Sacchi (ITA) on safeguarding and healthy eating.  36  WORLD GYMNASTICS YEARBOOK 2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `

        <div class="contentLink" style="top:845px;left:225px;width:182px;height:18px">
          <a href="https://sasaki-sports.co.jp" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="38-no" class="abs montAlternatesBd 38-no" style="top:336px;left:239px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 350}' ></h1>
        <h1 id="38-no" class="abs montAlternatesBd 38-no" style="top:398px;left:239px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 39}' ></h1>
        <h1 id="38-no" class="abs montAlternatesBd 38-no" style="top:472px;left:239px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 12}' ></h1>

        <a href="https://www.youtube.com/watch?v=9ah7QNyavLc" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:165px;left:475px;" src="/2025/static/_content/btn-play-white.png">
        </a>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:220px; left:475px;"
        onclick="pg38_gallery(0)"
        src="/2025/static/_content/btn-camera-white.png"
        />
      
      `,
      "script": `
        function onPageEnter() {
          pg38Anim = new TimelineMax();
          pg38Anim.fromTo(cOf("38-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[0])}}, 1)
          pg38Anim.fromTo(cOf("38-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[1])}}, 1.1)
          pg38Anim.fromTo(cOf("38-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[2])}}, 1.2);
        }

        function onPageLeave() {
          pg38Anim.stop();
          resetNumbers("38-no");
        }
      `,
      "searchText": "Sport  Trampoline & Tumbling  World’s finest put on a show in Pamplona The 38th FIG Trampoline ​​​​​​ Gymnastics World Championships took place in Pamplona, Spain, from 5-9 November 2025.  F  or the first time in a decade, the women’s and men’s Trampoline world champions both came from the People’s Republic of China, thanks to brilliant performances by Hu Yicheng and Wang Zisai at the Navarra Arena. Hu became the first Chinese woman since Li Dan in 2015 to win the Women’s Trampoline world title, while after silver medals at the last Worlds and Olympics, Wang took the final step to the top of the podium. Still just 19, he became one of the youngest gymnasts to capture the Men’s crown. Hu makes amends The 27-year-old Hu finished fourth at the 2023 World Championships and then missed out on the podium at Paris 2024 after bouncing off midway through her routine. In Pamplona an unsurpassed time of flight yielded a score of 57.350, enough to finish ahead of silver medallist Mori Hikaru (JPN) by just 0.03. Together with Fan Xinyi, Qiu Zheng and Zhu Xueying, Hu also helped China win the team  More than  350  gymnasts took part  39  nations were represented  12  nations won medals  Dong Dong elected  2012 Olympic champion Dong Dong (CHN) was elected as the Athletes’ Representative for Trampoline Gymnastics during the World Championships.  38  WORLD GYMNASTICS YEARBOOK 2025  competition and gained a Synchro bronze alongside Zhang Xinxin. Mori achieved a full set of medals by winning gold with Tanaka Saki in Synchro and being part of Japan’s bronze medal women’s team. Third-placed Sophiane Methot (CAN) scored a rare perfect 10 for horizontal displacement after landing every element in her routine directly in the centre of the trampoline. For the home crowd, there was a Spanish triumph to celebrate with Melania Rodriguez’s gold medal in the Women’s Double Mini-Trampoline (DMT) final. It was Rodriguez’s reward for a rare triple back pike dismount – a wildly ambitious routine from the first of four gymnasts to perform in the one-pass ‘super final’ – and it came with a layer of poignancy, given the passing of Spanish national coach Pablo Hinojar at the end of 2024. The Women’s Tumbling honours went to Arina Kaliandra (AIN), who prevailed after a thrilling showdown with 2023 world champion Candy Briere-Vetillard (FRA). With a score of 27.300, Kaliandra narrowly edged Briere-Vetillard to secure gold at her first World Championships. Wang takes full advantage With Olympic champion Ivan Litvinovich (AIN) having been eliminated in the Men’s semi-final, Wang emerged victorious from a final that featured several falls from several top contenders. Wang’s final score of 63.470 was enough to secure the gold by a healthy margin; he finished more than a point and a half ahead of Ruben Padilla (USA). Hayato Miyano (JPN) took bronze after controlling an astonishing eight triple somersaults in his routine."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
      
        <a href="https://www.youtube.com/watch?v=QDQ4pZGKr-E" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:665px;left:45px;" src="/2025/static/_content/btn-play-white.png">
        </a>

        <a href="https://www.youtube.com/watch?v=JdtuqKK8NH0" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:610px;left:45px;" src="/2025/static/_content/btn-play-white.png">
        </a>
      
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Trampoline & Tumbling  Sport  Technological innovation For the first time at a Worlds, the big screen in the arena – and the small screens in the media area – featured a map of the trampoline showing in which zone gymnasts were landing, with green points highlighting spot-on landings and red deductions for horizontal displacement.  Silver meant Padilla was the first U.S. men’s Trampoline gymnast in 51 years to reach the podium. The surprise medal capped a memorable Worlds for the busy American, who also earned his third consecutive Men’s DMT title and contributed to the U.S.’s goldmedal effort in the Team event. Litvinovich rebounded from individual disappointment to earn gold in the Synchro final with partner Andrei Builou. Both were also part of a gold-medal winning performance in the Men’s Trampoline Team event, together with Sebastsyan Stankevich and Stanislau Yaskevich. Last but not least, Australia’s Ethan McGuiness (AUS) reclaimed the Tumbling title he won in 2022, scoring 26.900 to finish clear of Denmark’s Magnus Lindholmer, who scored 26.200.  Pictured Main - Katsiaryna Yarshova, Stanislau Yaskevich (AIN) Left - Hu Yicheng (CHN)  Mixed Synchro back on the menu The penultimate day of the World Championships witnessed the final of the first new event added to the Trampoline programme in more than a quarter-century. Mixed Synchronised Trampoline features men and women jumping in unison. Synchronised Trampoline for pairs of men, women, or men and women jumping together was a medal event at the 1965 World Championships but had not been contested at a Worlds since. Eighteen nations took part and the final concluded with Katsiaryna Yarshova and Stanislau Yaskevich (AIN) as the new champions. Japan were second on the podium through Sakurai Ena and Miyano Hayato, while Seljan Mahsudova (AZE) and her younger brother Magsud Mahsudov became the first athletes from their country to win World Championship medals in Trampoline.  WORLD GYMNASTICS YEARBOOK 2025  39"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="40-no" class="abs montAlternatesBd 40-no" style="top:671px;left:51px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 900}' ></h1>

      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim.fromTo(cOf("40-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("40-no")[0])}}, 1);
        }

        function onPageLeave() {
          pg40Anim.stop();
          resetNumbers("40-no");
        }
      `,
      "searchText": "Sport  Trampoline & Tumbling  Next generation step into the spotlight The Trampoline Gymnastics Junior World Championships followed the senior event in Pamplona between 14-16 November.  R  ising star Alexsa Kachan of Australia struck gold twice at the Trampoline Gymnastics Junior World Championships in Spain in mid-November. Aggressive passes helped the 15-year-old from Windsor, New South Wales, win the Women’s Tumbling event. Just as assured on the Double Mini-Trampoline, Kachan tied with Evgeniia Zakharova (AIN) to defend her junior world title from 2023. Of all who took part in the Junior World Championships, Kachan was the only gymnast to prevail in multiple categories. The People’s Republic of China enjoyed two notable victories with Hu Keying and Yang Jinyi prevailing in Women’s and Men’s Trampoline respectively. France’s Sophie Darous and Alice Chaminade claimed the Women’s Synchronised title, while Georgia’s Tsotne Chkhaidze and Luka Lomtatidze earned gold in the Men’s competition. Laurent Lommaert (BEL) earned the Junior Men’s Tumbling title, while Rafael Pikofsky-Christiansen (USA) was the Men’s DMT champion.  More than  900  aspiring young gymnasts took part across the World Junior Championships and WAGC  40  WORLD GYMNASTICS YEARBOOK 2025  World Age Group Competitions The Junior World Championships were open to gymnasts born in 2009 or 2010, while other junior gymnasts were split into three further age categories (11-12-year-olds, 13-14-year-olds, and 17-21-year-olds) and competed in the World Age Group Competitions (WAGC) across four events: Men’s and Women’s Individual and Synchronised Trampoline, Double Mini-Trampoline (DMT) and Tumbling. Great Britain earned four WAGC titles thanks to Tumblers Hollie  Goodwin and Harry Bingham (13-14 age group) and Alfie Collier (17-21), while Abigail Bass added a DMT title (13-14). Nona Horemans and Lise Doorakkers brought Belgium golds in the 17-21 Tumbling and DMT finals respectively. Among the other multiple gold-medal nations, Tsuzuku Kanato earned double gold for Japan by winning the Men’s Trampoline title in the 17-21 age group and adding the Synchronised title with Imamoto Shusei. Rising Trampoline power Georgia attained a pair of Synchro victories from Anano Apakidze and Mariam Ragimovi in the 17-21 category, and Mariami Gabriadze and Elene Kirtadze in the 13-14 division.  Pictured Main - Aleksa Kachan (AUS) Above - Participants in Pamplona"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `

        <a href="https://www.youtube.com/watch?v=7CitYO8eidA" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:465px;left:365px;" src="/2025/static/_content/btn-play-black.png">
        </a>

        <div class="contentLink" style="top:244px;left:452px;width:70px;height:13px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4402168" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "STA T  Trampoline & Tumbling  E  Sport  PLAY OF  President of the Trampoline & Tumbling Technical Committee Christophe Lambert on the impact of the new Code of Points – and the arrival of Mixed Synchro.  Litvinovitch and Aliaeva on top The 2025 World Cup series ran from February to October, spanning six host countries.  I  van Litvinovich (AIN), the reigning Olympic champion in Men’s Trampoline, headed the list of winning gymnasts from the 2025 World Cup series. Litvinovich won the first three World Cups of the season in Baku (AZE), Riccione (ITA) and Coimbra (POR) to garner 180 points and the top ranking ahead of newcomer Maksim Didenko (AIN), who competed at all six World Cup events, taking silver in Cottbus (GER) on his way to 149 points. Sofiia Aliaeva (AIN) capped a breakout season with her first World Cup title. The 17-year-old collected a rainbow of medals throughout the summer events, including her first World Cup gold in Cottbus (GER), accumulating 203 points in all. Anzhela Bladtceva (AIN) also ended with 203 points following three silver-medal finishes, but the tie-break criteria favoured Aliaeva.  Danil Mussabayev and new jumping partner Nikita Tumakov (KAZ) won the Men’s Synchronised Pairs title and Sophiane Methot and Sarah Milette (CAN) took the equivalent Women’s title. Ruben Padilla (USA) and Diana Gago (POR) were respective winners of the World Cup series in Double Mini-Trampoline (DMT) while Tofig Aliyev (AZE) and Aleksandra Liamina (AIN) took top honours in Tumbling. Finally, Hristina Peneva and Kaloyan Petrov (BUL) made history for Bulgaria by capturing the first series title given in the new discipline of Mixed Synchronised Trampoline. Peneva and Petrov earned 102 points, edging out Seljan Mahsudova and Ali Niftaliyev (AZE) by a mere two points.  Pictured Main - Ivan Litvinovitch (AIN)  “When a gymnast goes on the trampoline, there’s more variety than before,” said Christophe Lambert, President of the Trampoline & Tumbling Technical Committee, speaking on the impact of the new Code of Points, introduced for the 2025-28 cycle. In the new code, certain spectacular backward elements have had their difficulty increased, incentivising gymnasts to try them out. This led to a rise in triple somersaults in individual events: Seljan Mahsudova (AZE) and Madaline Davidson (NZL) both completed routines with four triples at 2025 World Cup series events, while Yan Langyu (CHN) and Miyano Hayato (JPN) both landed eight in a single routine at the World Championships. In DMT, “Ruben Padilla broke the world record for difficulty this year,” added Lambert, noting that with the increase in difficulty, the Technical Committee is now looking at the question of athlete safety. Finally, the addition of Mixed Synchronised Trampoline to the World Championships has inspired the Technical Committee to aim for its inclusion in the Olympic Games – an ambition for the years to come.  WORLD GYMNASTICS YEARBOOK 2025  41"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:559px;left:454px;width:68px;height:13px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4380930" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Acrobatics  Expanded schedule spells more action  STA T  Sport  E  PLAY OF  New President of the Acrobatics Technical Committee Nikolina Hristova on her first year in the position. The new Acrobatic Gymnastics Technical Committee led by Nikolina Hristova (BUL) was completed early in 2025 with the addition of Carisa Laughon (USA) and Amir Mozes (ISR) as members.  There were five World Cups in this year’s series – two more than in 2024.  T  he World Cup series for Acrobatic Gymnastics featured five stops in 2025 – an increase on the three held the previous year. The series ran from March to June and comprised events in Puurs-Sint-Amands (BEL), Burgas (BUL), Baku (AZE), Aalen (GER) and Rzeszow (POL). The 2024 world champions in Women’s and Men’s Pairs – respectively Silke Macharis and Maysae Bouhouch (BEL) and Daniel Abbasov and Murad Rafiyev (AZE) – added to their title collections. In the case of Abbasov and Rafiyev, this was despite stiff competition from brothers Vsevelod and Yaroslav Ossolodkov (USA), who won gold in the three events in which they participated. In Mixed Pairs, Yevfrosyniia Kryvytska and Ivan Labunets (UKR)  42  WORLD GYMNASTICS YEARBOOK 2025  dominated the field by winning all four World Cup contests they entered. Emerging pair Milana Aliyeva and Sabir Aghayev (AZE), medallists at three of the five events, finished second. The longtime Ukrainian men’s group of Yurii Push, Yurii Savka, Stanislav Kukurudz and Taras Yarush went undefeated in every contest they took part in on their way to gold, while the triumphant women’s group came from Portugal with European champions Ema Fernandes, Leonor Carreira and Alicia Santos achieving wins in Puurs, Aalen and Rzeszow.  Pictured Yevfrosyniia Kryvytska, Ivan Labunets (UKR)  “Building connections with the continental unions” is a priority and Hristova visited DR Congo and progressed on a development project to help the sport grow in Africa, Asia and the Americas, which gained approval from World Gymnastics’s Executive Committee. The Code of Points was little changed. “To develop the sport in new countries, we need stability,” Hristova explains, noting the support from partners ACRO Companion and the International ACRO Foundation in this process. Finally, a new artistry evaluation tool, developed by the Technical Committee and trialled in 2025, promised judges clear guidance on how to evaluate artistry."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:95px;left:190px;width:230px;height:18px">
          <a href="https://ritmica-amaya.com" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:357px;left:491px;width:36px;height:13px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4379486" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:367px;left:435px;width:32px;height:13px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4379486" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Aerobics  STA T  Sport  E  PLAY OF  President of the Aerobics Technical Committee Tammy Yagi-Kitagawa on steps taken in 2025. Pictured Miquel Mane (ESP)  Mane wows as double World Cup winner  There were two World Cup events for Aerobic athletes in 2025.  T  wo-time world champion Miquel Mane (ESP) was one of the outstanding performers at the 2025 Aerobic Gymnastics World Cup events in Cantanhede (POR) and Tokyo (JPN). Mane triumphed in the Men’s Individual competition in both events, with Italy’s Davide Nacci taking silver each time, and also joined forces with Raul Toro and Sonia Vidal to win the Trio title in Cantanhede in their first World Cup competing together. Anastasiia Kurashvili (UKR), the 2022 world champion, won the Women’s Individual title in Cantanhede where she was the only female gymnast to break the 20-point barrier. Vasileia Faidra Diamanti (GRE) won silver  there to deliver a big result for Greek Aerobics. Maelys Lenclos (FRA), the 2024 world bronze medallist, took gold in Tokyo. In Mixed Pairs, Azerbaijan’s Vladimir Dolmatov and Madina Mustafayeva won gold in Cantanhede but had to settle for silver in Tokyo where home duo Kitazume Riri and Saito Mizuki emerged victorious. Reigning world champions Zhang Qingzhou and Wang Zhenhao and new teammate Fan Siwei won Trio gold for the People’s Republic of China in Tokyo. Fan was also part of the Chinese quintet that claimed Group gold, forcing the Italian group that had stood atop the podium in Cantanhede into second place.  Veloz elected The 2014 Men's Individual world champion, Ivan Veloz (MEX), was elected as the Athletes’ Representative for Aerobic Gymnastics during The World Games in Chengdu.  44  WORLD GYMNASTICS YEARBOOK 2025  “We made execution a little bit stricter,” says President of the Aerobics Technical Committee Tammy Yagi-Kitagawa of the 2025-28 Code of Points. The change will “accentuate artistry” and by the second World Cup in Tokyo, athletes were already adjusting to it. A busy 2025 included joint meetings with the Rhythmic and Acrobatic Gymnastics Technical Committees, and intercontinental and international judges’ courses, which raised the number of judges with high-class brevets to almost 300. Additionally, the STS (Sports Training Systems) platform was expanded, meaning more educational resources for judges and coaches, while a new live scoring system was implemented to replace manual calculations. Finally, Yagi-Kitagawa underlines an initiative for the future: the Aerobic Gymnastics Wellness Convention, which will include wellness-oriented movement activities and could potentially facilitate the introduction of Pilates."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:832px;left:394px;width:225px;height:28px">
          <a href="https://eurotramp.com" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `

        <a href="https://www.youtube.com/live/coXE3qvcrGk?si=TOUnmjX3XWiYH4rq" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:715px;left:354px;" src="/2025/static/_content/btn-play-white.png">
        </a>

        <a href=" https://www.youtube.com/live/KrnZnYCNjXs?si=Zzq-oFLCn3Zp6dhT" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:775px;left:354px;" src="/2025/static/_content/btn-play-white.png">
        </a>
      
        <div class="contentLink" style="top:605px;left:512px;width:36px;height:13px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=438198" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:616px;left:435px;width:32px;height:13px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=438198" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Parkour  Amsterdam World Cup breaks new ground There were two World Cups in 2025, starting with a new venue in the Netherlands.  T  he World Cup season in May and June comprised a groundbreaking Amsterdam (NED) event before the athletes reconvened in the more familiar setting of Montpellier (FRA). Amsterdam’s first World Cup was held indoors in a repurposed factory and broke new ground in having separate courses for Speed and Freestyle runs, an experiment widely welcomed by the athletes. Organised by Dutch Gymnastics together with Dutch Parkour and Janssen-Fritsen, it was a successful event according to World Gymnastics’ Parkour Technical Committee President Charles Perriere, and was followed by a Montpellier World Cup held as part of the Festival  of Extreme Sports (FISE), which delighted Perriere for the volume of spectators there purely for the Parkour. Caryl Cordt-Moller (SUI) took the World Cup title in Men’s Speed after gold in Amsterdam and silver in Montpellier while Miranda Tibbling (SWE) did it the other way round, finishing second in Amsterdam in her first major competition after a career-threatening knee injury, before triumphing in Montpellier. Ella Bucio (MEX) and Noa Man (NED) shared the Women’s Freestyle title after a gold medal each, the latter’s won on home ground in Amsterdam, while successive silvers earned Shea Rudolph (USA) the Men’s Freestyle crown.  Navarro gets the vote Stefanny Navarro (ESP) was elected by her peers as Athletes' Representative for Parkour during The World Games. The 2022 silver medallist in Speed retired from competition directly after the Chengdu event to start in the role.  STA T  Sport  E  PLAY OF  Parkour Technical Committee president Charles Perriere on the drive to expand the sport’s reach. “We're travelling the world for our education programme,” says Charles Perriere, and in 2025 that push included courses in Madagascar and Canada, with the latter hosting Parkour’s first Age Group Programme camp in North America. Held in Chertsey, Quebec, Perriere describes it as an “introduction to Parkour, the sport version” for Canada’s Parkour community, part of a drive to promote Parkour in North America and Africa. Looking ahead, the technical committee agreed to renew their collaboration with the FISE Festival and with Hurricane, the provider of Parkour fields of play, and oversee the new Code of Points’ introduction, including checkpoint zones to ensure safety in the Speed competition, and a stipulation that national federations must register at least one woman in a full delegation of eight athletes.  Pictured Noa Man (NED)  46  WORLD GYMNASTICS YEARBOOK 2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:829px;left:190px;width:249px;height:18px">
          <a href="https://gaofeisports.com" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `

        <img class="abs halfScaleC 48-quote" style="top:545px;left:360px;" src="/2025/static/_content/48-quote-1.png"/>

        <div class="contentLink" style="top:232px;left:296px;width:101px;height:13px">
          <a href="https://www.theworldgames.org/sports/Gymnastics-59" target="_blank"></a>
        </div>

        <a href="https://live.gymnastics.sport/news.php?idevent=16882" target="_blank">
          <img class="abs halfScaleC pointer" style="top:805px;left:152px;" src="/2025/static/_content/48-btn-1.png">
        </a>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:420px; left:430px;"
        onclick="pg48_gallery(0)"
        src="/2025/static/_content/btn-camera-white.png"
        />
      
      `,
      "script": `
        function onPageEnter() {
          pg48Anim = new TimelineMax();
          pg48Anim.fromTo(cOf("48-quote"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg48Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Sport  The World Games  A first for Synchro as Tumbling final thrills Synchronised Trampoline made its return to The World Games, while the Tumbling competition produced a dramatic finish.  T  he men’s Tumbling final lit up the Trampoline & Tumbling competition in Chengdu as Tofig Aliyev (AZE) and Kaden Brown (USA) each produced performances that will live long in the memory. First, Aliyev landed the first-ever ‘full-full-full’ – a triple-twisting triple back tuck somersault that turned the 20-year-old into an internet sensation. Aliyev’s heroics heaped pressure on defending World Games champion Brown, who required the pass of his life to defend his title. Yet he simply took a deep breath and launched himself into a near-flawless Miller to double layout to triple back tuck – a feat that earned him the gold. “Aliyev did a very nice pass with a very high difficulty but Brown then went just after and did a perfect pass – very hard difficulty too and a totally different concept. He did it so well,” reflected Christophe Lambert, President of the Trampoline & Tumbling Technical Committee in looking back on the event, which also featured a bronze for Fred Teague (GBR).  48  WORLD GYMNASTICS YEARBOOK 2025  By contrast, defending women’s Tumbling champion Candy BrièreVetillard (FRA) had to settle for silver, ahead of Alexandra Efraimoglou (GRE) but behind Megan Kealy (GBR). Despite being a world champion in her own right, Kealy had hesitated to try out for the British Tumbling squad for Chengdu. Yet once there, she delivered a spectacular performance to capture the biggest title of her storied career. In Synchronised Trampoline’s debut at The World Games, the unusual head-to-head format seemed to destabilise many of the men’s competitors. Portugal’s Lucas Santos and Gabriel Albuquerque came out on top ahead of Jordy Mol and Rikkert Veldhuizen (NED) and Caio Lauxtermann and Fabian Vogel (GER), though there were unfinished exercises even from the strongest of pairs. By contrast, the women’s champions from the People’s Republic of China, Hu Yicheng and Zhang Xinxin, got through every exercise without a major mistake, finishing top of a podium that also held silver medallists Tanaka Saki and Mori Hikaru (JPN), and Sarah Milette and Sophiane Méthot (CAN). Always in contention but seldom champion on the biggest stages, Portugal’s Diana Gago enjoyed the view from the podium as she claimed the women’s Double-Mini Trampoline (DMT) gold ahead of Grace Harder (USA) and Melania Rodriguez (ESP). In another surprise, Men’s DMT gold was won by Brent Deklerck (BEL), with Omo Aikeremiokha (GBR) and Gavin Dodd (CAN) completing the podium. World champion Ruben Padilla (USA) arrived in Chengdu as the favourite but missed a takeoff on his first pass in a high-quality qualification round and failed to progress.  It was a head-tohead competition – the final saw the two of them fighting for the gold. It was just fantastic.” Christophe Lambert  President of the Trampoline & Tumbling Technical Committee, on the Men’s Tumbling final"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="49-no" class="abs montAlternatesBd 49-no" style="top:538px;left:405px; font-size: 2.5em; font-weight: 300; color: #1d193a; padding: 0px; margin: 0px;"  data-number='{"to": 13}' ></h1>
      
      `,
      "script": `
        function onPageEnter() {
          pg49Anim = new TimelineMax();
          pg49Anim.fromTo(cOf("49-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("49-no")[0])}}, 1);
        }

        function onPageLeave() {
          pg49Anim.stop();
          resetNumbers("49-no");
        }
      `,
      "searchText": "The World Games  Sport  13  countries won medals among the 19 taking part  Pictured Main - Kaden Brown (USA) Left - Lucas Santos, Gabriel Albuquerque (POR)  WORLD GYMNASTICS YEARBOOK 2025  49"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": `
      
        <img class="abs halfScaleC 50-quote" style="top:387px;left:-15px;" src="/2025/static/_content/50-quote-1.png"/>

        <h1 id="50-no" class="abs montAlternatesBd 50-no" style="top:318px;left:449px; font-size: 2.5em; font-weight: 300; color: #1d193a; padding: 0px; margin: 0px;"  data-number='{"to": 9}' ></h1>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:670px; left:175px;"
        onclick="pg50_gallery(0)"
        src="/2025/static/_content/btn-camera-white.png"
        />

      `,
      "script": `
        function onPageEnter() {
          pg50Anim = new TimelineMax();
          pg50Anim.fromTo(cOf("50-quote"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("50-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("50-no")[0])}}, 1.1)
        }

        function onPageLeave() {
          pg50Anim.stop();
          resetNumbers("50-no");
        }
      `,
      "searchText": "Sport  The World Games  Spanish and Belgian pairs shine In front of thrilled audiences at the Dong'an Lake Sports Park Gymnasium, some of the world’s leading Acrobatic gymnasts put on an impressive show.  I  n the Men’s Pairs competition, Jose Moreno and Juan Daniel Molina (ESP) had a competition to remember amidst a year of outstanding success. Having won the European All-Around title in Luxembourg in April, they took World Games gold in August. In arguably the most competitive category of the competition, they took on three sets of world champions, including eventual silver medallists Daniel Abbasov and Murad Rafiyev (AZE) and bronze medallists Miguel Lopes and Gonçalo Parreira (POR).  The event was very successful for our discipline and showed the beauty, difficulty and athletic level of our sport to an international audience.” Nikolina Hristova President of the Acrobatics Technical Committee  50  WORLD GYMNASTICS YEARBOOK 2025  The Women’s Pairs title went to reigning world champions Maysae Bouhouch and Silke Macharis (BEL), who rebounded in vibrant fashion after losing at the European Championships against Anhelina Cherniavska and Ruzanna Vecheruk (UKR). With a new Combined routine, the Belgian duo delighted the crowd and judges alike to add a new title – World Games champions – to their collection, relegating the Ukrainians to silver. Beatriz Carneiro and Inês Faria (POR) took bronze, providing a  9  countries won medals among the 14 taking part"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "The World Games  Sport  second World Games medal for Carneiro four years after her first. After Mixed Pairs silver at the last World Championships, a major title was all the elegant Yevfrosyniia Kryvytska and Ivan Labunets (UKR) were missing. The Ukrainians, whose calling card is their retelling of ‘Romeo and Juliet’, made sure they earned it by leading from start to finish in the Mixed Pairs competition. Lara Fernandes and Guilherme Henriques (POR) and Yonatan Fridman and Amy Refaeli (ISR) completed the top three. The first Chinese Women’s Group to win the overall world title in three decades – Ding Wenyan, Gu Quanjia and Ma Yixing – delighted the home spectators by continuing their golden run with a World Games title at home, ahead of the United States and Israel. Finally, Or Abraham, Tomer Offir, Lior Borodin and Rotem Amihai (ISR) capitalised on a mistake by the favoured Chinese men’s four to win their country’s first gold in the Men’s Group event. Ukraine and Great Britain filled out the podium.  Pictured Main - Jose Moreno, Juan Daniel Molina (ESP) Left - Silke Macharis, Maysae Bouhouch (BEL)  WORLD GYMNASTICS YEARBOOK 2025  51"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `
      
        <img class="abs halfScaleC 52-quote" style="top:637px;left:-20px;" src="/2025/static/_content/52-quote-1.png"/>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:325px; left:425px;"
        onclick="pg52_gallery(0)"
        src="/2025/static/_content/btn-camera-white.png"
        />

      `,
      "script": `
        function onPageEnter() {
          pg52Anim = new TimelineMax();
          pg52Anim.fromTo(cOf("52-quote"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
          pg52Anim.stop();
        }
      `,
      "searchText": "Sport  The World Games  Japanese pair sign off in style A golden farewell, dominant home performances and another triumph for Hungary all featured in a compelling Aerobics competition in Chengdu.  I  f The World Games featured some memorable performances from the host country’s Aerobic gymnasts, who attained the podium in three of the four categories, the most stirring story belonged arguably to Japan’s Kitazume Riri and Saito Mizuki. World Games gold was the one medal missing from an extensive collection amassed over nearly a decade by this pair, who were training partners as far back as their schooldays. Such was their determination to claim the Mixed Pairs title that Kitazume and Saito stopped training as individuals earlier in the year to focus on their final goal before retiring. The investment paid off in Chengdu, where the 2024 world champions overcame Azerbaijan’s Vladimir Dolmatov and Madina Mustafayeva (AZE), whose elegant performance to Duncan Lawrence’s ‘Arcade’ threatened to steal the show. However, there was no beating Japan’s Aerobic masters, whose routine to Benson Boone’s ‘Beautiful Things’ tapped into a deep well of feeling, highlighted by Saito’s tears at the finish. Bronze went to Ukraine’s Anastasiia Kurashvili and Stanislav Halaida in another milestone moment for their country.  The organisation was very good and the judging was excellent.” Tammy Yagi-Kitagawa President of the Aerobics Technical Committee  52  WORLD GYMNASTICS YEARBOOK 2025  There was much for the home crowd to cheer about, with many of the People’s Republic of China’s reigning world champions earning fresh golds. Fan Siwei combined forces with 2024 gold medallists Wang Zhenhao and Zhang Qingying to triumph in Trio, ahead of Italy and Bulgaria. Fan also joined teammates Feng Lei, Liang Wenjie, Teng Hao and Xu Tong as they took the Group title that China had last won in 2017, finishing clear of Italy and Romania and making 24-year-old Fan the only gymnast to leave Chengdu as a double World Games champion. Every member of Hungary’s World Championshipwinning team – Fruzsina Fejer, Kamilla Goda, Tunde Himmel, Antonia Konig, Zoltan Locsei, Anna Makranszki, Andras Agoston Mikulecz and Vanessza Ruzicska – returned to help Hungary secure The World Games gold with a chess-themed routine. The Hungarians checkmated South Korea and China, and came up with another golden performance at the European Championships in Ganja (AZE) to close out their year."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.jpg",
      "zoom": null,
      "content": `
      
        <h1 id="53-no" class="abs montAlternatesBd 53-no" style="top:550px;left:456px; font-size: 2.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 9}' ></h1>
      
      `,
      "script": `
        function onPageEnter() {
          pg53Anim = new TimelineMax();
          pg53Anim.fromTo(cOf("53-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("53-no")[0])}}, 1)
        }

        function onPageLeave() {
          pg53Anim.stop();
          resetNumbers("53-no");
        }
      `,
      "searchText": "9  countries won medals among the 14 taking part  Pictured Kitazume Riri, Saito Mizuki (JPN)  WORLD GYMNASTICS YEARBOOK 2025  53"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.jpg",
      "zoom": null,
      "content": `
      
        <img class="abs halfScaleC 54-quote" style="top:625px;left:126px;" src="/2025/static/_content/54-quote-1.png"/>

        <!--Gallery-->
        <img
        class="abs halfScaleC halfpulse animatedpulse pointer"
        style="top:710px; left:140px;"
        onclick="pg54_gallery(0)"
        src="/2025/static/_content/btn-camera-white.png"
        />

      `,
      "script": `
        function onPageEnter() {
          pg54Anim = new TimelineMax();
          pg54Anim.fromTo(cOf("54-quote"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
          pg54Anim.stop();
        }
      `,
      "searchText": "Sport  The World Games  World champions add to their collections Established stars held their ground, new winners emerged and Argentina celebrated historic podium finishes in an electrifying Parkour showcase in Chengdu.  R  eigning world champions Caryl Cordt-Moller (SUI) and Shang Chunsong (CHN) added ‘The World Games gold medallist’ to already stellar resumes at the Xinglong Lake Hubin Arena in Chengdu. Cordt-Moller, who rose to fame as the ‘masked torchbearer’ of the Paris 2024 Olympic Games opening ceremony, reigned over the Men’s Speed runs in Parkour’s second appearance at The World Games. He saw off a familiar rival in Jaroslav Chum (CZE), claiming his first World Games title with a time of 25.30 seconds. Andrea Consolini (ITA) won the bronze for his second World Games medal. In Men’s Freestyle, 2024 World Championships runner-up Shiohata Mutsuhiro (JPN) seized the stage to grab his first major title, 1.7 points ahead of Eloan Hitz (FRA) with Shea Rudolph (USA) completing the podium. In the women’s events, Miranda Tibbling (SWE) secured a second consecutive World Games title in Speed, outpacing her friend and rival Noa Man (NED) by 1.05 seconds in a repeat of the result at The World Games in 2022.  In the Women’s Freestyle competition, Chunsong put on a show with a gold-medal performance that rewarded her decision to switch to Parkour from Women's Artistic. Between her work on the bars and acrobatics on the floor, she ended with a lead of more than three points over her closest rival, Japan’s Nagai Nene. After several top-five performances dating back to 2023, silver was a breakthrough for Nene and her best international finish at a World Gymnastics event to date. Finally, Sara Banchoff Tzancoff (ARG) won bronzes in Women’s Speed and Freestyle, both milestone medals for Argentina.  It was the first time that China had organised a Parkour event for World Gymnastics and the tickets were sold out.” Pictured Main - Caryl Cordt-Moller (SUI) Small - Shang Chunsong (CHN)  54  WORLD GYMNASTICS YEARBOOK 2025  Charles Perriere  President of the Parkour Technical Committee"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 54,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg55.jpg",
      "zoom": null,
      "content": `

        <h1 id="55-no" class="abs montAlternatesBd 55-no" style="top:682px;left:438px; font-size: 2.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 10}' ></h1>
      
      `,
      "script": `
        function onPageEnter() {
          pg55Anim = new TimelineMax();
          pg55Anim.fromTo(cOf("55-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("55-no")[0])}}, 1)
        }

        function onPageLeave() {
          pg55Anim.stop();
          resetNumbers("55-no");
        }
      `,
      "searchText": "The World Games  Sport  10  countries won medals among the 18 taking part  WORLD GYMNASTICS YEARBOOK 2025  55"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 55,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg56.jpg",
      "zoom": null,
      "content": `
      
        <img class="abs halfScaleC 56-speech-bubble" style="top:23px;left:-23px;" src="/2025/static/_content/56-speech-bubble-1.png"/>
        <img class="abs halfScaleC 56-subtitle" style="top:99px;left:-98px;" src="/2025/static/_content/56-title-1.png"/>
        <img class="abs halfScaleC 56-subtitle" style="top:189px;left:101px;" src="/2025/static/_content/56-subtitle-1.png"/>

        <img class="abs halfScaleC 56-speech" style="top:309px;left:159px;" src="/2025/static/_content/56-speech-4.png"/> 
        <img class="abs halfScaleC 56-speech" style="top:128px;left:-116px;" src="/2025/static/_content/56-speech-1.png"/>
        <img class="abs halfScaleC 56-speech" style="top:533px;left:160px;" src="/2025/static/_content/56-speech-6.png"/>
        <img class="abs halfScaleC 56-speech" style="top:125px;left:158px;" src="/2025/static/_content/56-speech-2.png"/>
        <img class="abs halfScaleC 56-speech" style="top:533px;left:-115px;" src="/2025/static/_content/56-speech-5.png"/>  
        <img class="abs halfScaleC 56-speech" style="top:309px;left:-115px;" src="/2025/static/_content/56-speech-3.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg56Anim = new TimelineMax();
          pg56Anim.fromTo(cOf("56-speech-bubble"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)
          .staggerFromTo(cOf("56-subtitle"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.2)
          .staggerFromTo(cOf("56-speech"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4);
        }

        function onPageLeave() {
          pg56Anim.stop();
        }
      `,
      "searchText": "Sport  Hear from the athletes  HEAR FROM THE ATHLETES Discover the motivations behind the moments  Men’s Artistic  Amirabbas Mojahed (IRI) on the impact of Olympic finalist Mahdi Olfati on him as a rising junior:  Beatriz Carneiro (POR) on how gymnastics shaped her (via Instagram):  “There is an Iranian Olympian who has come to the Olympics and has made it to the finals. It gives us a lot of hope that we can do it too.”  “Gymnastics taught me that nothing great is achieved without sacrifice. There were days when my body begged for rest, but my soul demanded one more effort. [...] it was also there that I discovered the magic of overcoming, the beauty of transforming the body into poetry in motion, and the strength that arises when we believe in ourselves and in others.”  Rhythmic (Individual)  Parkour  Luana Gomes (ANG), the 2025 African All-Around champion, reflects on her performance at the World Championships in Rio de Janeiro (via Instagram):  Shang Chunsong (CHN) after winning the Women's Freestyle Parkour gold at The World Games 2025 (via Xinhua.net):  “In the last few months I’ve experienced intense changes, moments of uncertainty and I even thought about giving up. But still, I chose to fight for my dreams. [...] The biggest result was to feel the heart at ease and the certainty that I danced with my soul, leaving a piece of myself in every gesture.”  “There’s no set path or standard answer – you face your fears, push through endless obstacles, and go beyond your limits. Life is the same, full of ups and downs, but if you grit your teeth and keep going, you’ll get through.”  Trampoline & Tumbling  Aerobics  Lani Spissens (BEL) on what it meant to her to be in The World Games final (via Instagram):  Julieta Perazza (URU) on becoming a South American champion (via Instagram):  “This is not just a ranking. It’s proof that hard work, never giving up, and believing in yourself can make a dream real. Even the dreams that seem too big.”  56  Acrobatics  WORLD GYMNASTICS YEARBOOK 2025  “This medal goes to little Juli, who dreamed it with all her might and who didn't stop training until she achieved it.”"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 56,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg57.jpg",
      "zoom": null,
      "content": `
      
        <img class="abs halfScaleC 57-speech" style="top:139px;left:166px;" src="/2025/static/_content/57-speech-4.png"/> 
        <img class="abs halfScaleC 57-speech" style="top:-71px;left:-116px;" src="/2025/static/_content/57-speech-1.png"/>
        <img class="abs halfScaleC 57-speech" style="top:310px;left:165px;" src="/2025/static/_content/57-speech-6.png"/>
        <img class="abs halfScaleC 57-speech" style="top:-71px;left:163px;" src="/2025/static/_content/57-speech-2.png"/>
        <img class="abs halfScaleC 57-speech" style="top:310px;left:-110px;" src="/2025/static/_content/57-speech-5.png"/>  
        <img class="abs halfScaleC 57-speech" style="top:139px;left:-115px;" src="/2025/static/_content/57-speech-3.png"/>
        <img class="abs halfScaleC 57-speech" style="top:563px;left:-80px;" src="/2025/static/_content/57-speech-7.png"/>
        <img class="abs halfScaleC 57-image" style="top:535px;left:167px;" src="/2025/static/_content/57-image-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg57Anim = new TimelineMax();
          pg57Anim.staggerFromTo(cOf("57-speech"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4)
          .fromTo(cOf("57-image"), 0.7, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.3);
        }

        function onPageLeave() {
          pg57Anim.stop();
        }
      `,
      "searchText": "Hear from the athletes  Acrobatics Vsevelod Ossolodkov (USA) on why he does Acro (via Instagram): “We choose to do this not because it is easy, but because it is hard.”  Sport  Women’s Artistic  Elsabeth Black (CAN) on how to train properly (via International Gymnast Magazine): “There always must be a balance between being focused and serious, still having fun and enjoying the moment.”  Aerobics  Trampoline & Tumbling  Miquel Mane (ESP) on the life of a gymnast (via Instagram):  Ethan McGuinness (AUS) on hesitating to compete at the World Championships, which he ended up winning:  “Beyond the results, there is a path that very few see, imagine, or try to appreciate, but those of us who live it are very aware that we are already champions. Because sharing this process is one of the most special things this sport can give us.”  “In my head I was really thinking of withdrawing, but my family had already booked their holiday, so I thought, ‘I’ll give it a crack’.”  Parkour  Rhythmic (Group)  Jaroslav Chum (CZE) on retiring from international competition after The World Games 2025:  Suzuki Ayuka (JPN) on her retirement aged 26 after winning Group All-Around gold in Rio (via Instagram):  “I have my own Parkour Academy in Prague and I will share Parkour with kids and their parents because the emotion is everything.”  “Every day has been harder than I could have imagined, but I kept pushing myself, giving all my strength to achieve my goals. My competitive life was priceless, where I experienced many moments that burst with joy.”  Gymnastics for All Welsch Master Team (SUI) after winning the 2025 World Gym for Life Challenge in Portugal: “We are more determined than ever to keep going, and we’re about to start a new production. One might think this title is an end in itself, but it simply makes us want even more to go and win new ones.”  WORLD GYMNASTICS YEARBOOK 2025  57"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 57,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg58.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 58,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg59.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "MEDIA AND MARKETING"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 59,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg60.jpg",
      "zoom": null,
      "content": `

        <img class="abs halfScaleC 60-quote" style="top:187px;left:359px;" src="/2025/static/_content/60-quote-1.png"/>

        <img class="abs halfScaleC 60-icon" style="top:442px;left:211px;" src="/2025/static/_content/60-icon-1.png"/>
        <img class="abs halfScaleC 60-text" style="top:415px;left:245px;" src="/2025/static/_content/60-text-1.png"/>
        <h1 id="60-no" class="abs montAlternatesBd 60-no" style="top:467px;left:333px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 4381, "comma" : true}' ></h1>

        <img class="abs halfScaleC 60-icon" style="top:536px;left:190px;" src="/2025/static/_content/60-icon-2.png"/>
        <img class="abs halfScaleC 60-text" style="top:513px;left:252px;" src="/2025/static/_content/60-text-2.png"/>
        <h1 id="60-no" class="abs montAlternatesBd 60-no" style="top:564px;left:333px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 100, "append" : "+"}' ></h1>

        <img class="abs halfScaleC 60-icon" style="top:655px;left:196px;" src="/2025/static/_content/60-icon-3.png"/>
        <img class="abs halfScaleC 60-text" style="top:585px;left:242px;" src="/2025/static/_content/60-text-3.png"/>
        <h1 id="60-no" class="abs montAlternatesBd 60-no" style="top:660px;left:333px; font-size: 2.5em; font-weight: 300; color: #34b8cc; padding: 0px; margin: 0px;"  data-number='{"to": 86.6, "decimals" : 1, "append" : "%"}' ></h1>

        <img class="abs halfScaleC 60-text-4" style="top:799px;left:87px;" src="/2025/static/_content/60-text-4.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg60Anim = new TimelineMax();
          pg60Anim.fromTo(cOf("60-quote"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("60-icon"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1.3)
          .staggerFromTo(cOf("60-text"), 0.6, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.5)
          .fromTo(cOf("60-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("60-no")[0])}}, 1.7)
          .fromTo(cOf("60-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("60-no")[1])}}, 1.8)
          .fromTo(cOf("60-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("60-no")[2])}}, 1.9)
          .fromTo(cOf("60-text-4"), 0.6, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
          pg60Anim.stop();
          resetNumbers("60-no");
        }
      `,
      "searchText": "Media and Marketing  Rebranding  Shaping the future of gymnastics A renewed global identity designed to unite, modernise and amplify gymnastics worldwide, from grassroots to elite level.  T  he International Gymnastics Federation (FIG) entered a new chapter in December 2025, announcing a new brand and identity: World Gymnastics. This rebrand will continue to further the organisation’s purpose of inspiring movement, promoting the sport for everyone, for life. Following extensive consultation with athletes, member federations, fans and global partners over multiple years, the rebrand defined clear priorities: • Strengthening athlete visibility and safeguarding • Enhancing fan engagement and event experience • Expanding global participation • Clarifying pathways across all disciplines The new brand introduces a new logo and visual identity and reflects the commitment to promoting gymnastics at every level, from grassroots participation to elite international competition. “World Gymnastics represents our mission with clarity and purpose,” said Morinari Watanabe, President of World Gymnastics. “The name reinforces our role as a global centre for athletes, coaches, fans and partners. This change goes far beyond a rebranding. It is a promise to elevate the sport and expand access to gymnastics worldwide.” A central pillar of the rebrand is the introduction of clearly defined identities for each gymnastics discipline. Each of the eight disciplines now benefits from a tailored visual expression within a unified framework, enhancing storytelling, increasing visibility and allowing the unique character of each discipline to shine on the world stage.  60  WORLD GYMNASTICS YEARBOOK 2025  The wider visual identity of World Gymnastics emphasises movement, unity and the expressive nature of the sport, placing the athlete firmly at the centre. The eight discipline brands integrate these core elements with distinct artistic styles inspired by each discipline’s personality and audience. “Gymnastics is one of the world’s most inspiring and expressive sports,” concluded Watanabe. “World Gymnastics captures that energy while strengthening our global foundation for future generations.”  This change goes far beyond a rebranding. It is a promise to elevate the sport and expand access to gymnastics worldwide.” Morinari Watanabe  President of World Gymnastics  Listening  4,381  voices heard across two surveys, in 7 languages Conversing  100+  stakeholders interviewed in workshops and 1-2-1 sessions Choosing  86.6% selected  from 119 nations worldwide  A brand shaped by thousands. Owned by all."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 60,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg61.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Rebranding  Media and Marketing  Project journey Imagining  2022  Building  2022-2023  A vision from President Morinari Watanabe, entrusted to the Branding, Marketing & TV Rights Commission, chaired by Tadashi Fujita, President of the Japan Gymnastics Association.  Surveys, workshops and conversations across the world shaped a new purpose, mission and values.  Every shape in our new icon was crafted with intent. Behind a clean silhouette lies a layered reading – a tribute to our history, our athletes and the diversity of our disciplines.  Ribbon of movement The icon is built around the idea of a trail of motion following the athlete, styled like a ribbon – evoking the fluidity and grace at the core of gymnastics.  Deciding  2024-2025  2026-2028  The FIG Congress in Doha approved the new name World Gymnastics. Logos and identity followed in 2025.  Brand launch in December 2025, then a global rollout – carried forward by federations, members and the entire gymnastics family.  Globe Built on a circular structure, the icon evokes a globe – reflecting our global reach and the universal language of our sport.  A solid base As the ribbon flows around the icon, it forms a solid block beneath the athlete – evoking the strength, support and apparatus that ground our sport.  Living it  Athlete At the heart of the icon, the athlete figure performs a backflip – a movement shared across all our disciplines.  ‘G’ A subtle letter ‘G’ (Gymnastics) built into the structure by the athlete figure.  ‘W’ A key element of the icon shaped like the letter ‘W’ (World).  A runway forward The base of the icon stretches into an elongated path leading up to the athlete – evoking momentum, take-off and the drive that propels every athlete.  WORLD GYMNASTICS YEARBOOK 2025  61"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 61,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg62.jpg",
      "zoom": null,
      "content": `
      
      <div class="contentLink" style="top:343px;left:378px;width:75px;height:75px;border-radius:10px;">
        <a href="https://qrfy.io/p/bVBWfWu3kq?utm_source=qrcode&utm_medium=social&utm_campaign=45869316" target="_blank"></a>
      </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Media and Marketing  Fan engagement  Reaching new audiences World Gymnastics once again enjoyed strong growth across all social media platforms in 2025, with TikTok in particular proving a success. All percentage increases are measured against 2024  SCAN HERE  for our social  media channels  62  WORLD GYMNASTICS YEARBOOK 2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 62,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg63.jpg",
      "zoom": null,
      "content": `

        <!-- first section -->
      
        <img class="abs halfScaleC 63-sm-icon" style="top:98px;left:44px;" src="/2025/static/_content/63-icon-1.png"/>
        <img class="abs halfScaleC 63-sm-text" style="top:158px;left:23px;" src="/2025/static/_content/63-text-1.png"/>

        <img class="abs halfScaleC 63-icon" style="top:119px;left:127px;" src="/2025/static/_content/63-icon-2.png"/>
        <img class="abs halfScaleC 63-text" style="top:172px;left:105px;" src="/2025/static/_content/63-text-2.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:220px;left:138px; font-size: 1.16em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 2.6, "decimals" : 1, "append" : "m"}' ></h1>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:242px;left:131px; font-size: 1em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 150, "preppend" : "(+", "append" : "%)"}' ></h1>
        
        <img class="abs halfScaleC 63-line-vert" style="top:74px;left:216px;" src="/2025/static/_content/63-line-1.png"/>

        <img class="abs halfScaleC 63-icon" style="top:134px;left:226px;" src="/2025/static/_content/63-icon-3.png"/>
        <img class="abs halfScaleC 63-text" style="top:172px;left:208px;" src="/2025/static/_content/63-text-3.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:220px;left:244px; font-size: 1.16em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 35, "append" : "m"}' ></h1>
         <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:241px;left:234px; font-size: 1em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 221, "preppend" : "(+", "append" : "%)"}' ></h1>

        <img class="abs halfScaleC 63-line-vert" style="top:74px;left:314px;" src="/2025/static/_content/63-line-1.png"/>

        <img class="abs halfScaleC 63-icon" style="top:126px;left:325px;" src="/2025/static/_content/63-icon-4.png"/>
        <img class="abs halfScaleC 63-text" style="top:179px;left:329px;" src="/2025/static/_content/63-text-4.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:220px;left:334px; font-size: 1.16em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 6.6, "decimals" : 1, "append" : "m"}' ></h1>

        <img class="abs halfScaleC 63-line" style="top:268px;left:-20px;" src="/2025/static/_content/63-line-2.png"/>

        <img class="abs halfScaleC 63-icon" style="top:260px;left:121px;" src="/2025/static/_content/63-icon-5.png"/>
        <img class="abs halfScaleC 63-text" style="top:320px;left:93px;" src="/2025/static/_content/63-text-5.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:344px;left:143px; font-size: 1.16em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 96, "append" : "k"}' ></h1>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:366px;left:131px; font-size: 1em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 158, "preppend" : "(+", "append" : "%)"}' ></h1>

        <img class="abs halfScaleC 63-line-vert" style="top:231px;left:216px;" src="/2025/static/_content/63-line-6.png"/>

        <img class="abs halfScaleC 63-icon" style="top:264px;left:210px;" src="/2025/static/_content/63-icon-6.png"/>
        <img class="abs halfScaleC 63-text" style="top:320px;left:208px;" src="/2025/static/_content/63-text-6.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:344px;left:236px; font-size: 1.16em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 134.1, "decimals" : 1, "append" : "k"}' ></h1>
        <img class="abs halfScaleC 63-line-vert" style="top:231px;left:314px;" src="/2025/static/_content/63-line-6.png"/>

        <img class="abs halfScaleC 63-text-arrow" style="top:234px;left:290px;" src="/2025/static/_content/63-text-7.png"/>
        <img class="abs halfScaleC 63-image" style="top:-93px;left:331px;" src="/2025/static/_content/63-phone-1.png"/>
        <img class="abs halfScaleC 63-line" style="top:411px;left:-111px;" src="/2025/static/_content/63-line-4.png"/>
        <img class="abs halfScaleC 63-box" style="top:349px;left:41px;" src="/2025/static/_content/63-box-1.png"/>
        <img class="abs halfScaleC 63-image" style="top:283px;left:340px;" src="/2025/static/_content/63-socials-1.png"/>


        <!-- second section -->

        <img class="abs halfScaleC 63-sm-icon-2" style="top:414px;left:45px;" src="/2025/static/_content/63-icon-7.png"/>
        <img class="abs halfScaleC 63-sm-text-2" style="top:483px;left:17px;" src="/2025/static/_content/63-text-8.png"/>

        <img class="abs halfScaleC 63-icon-2" style="top:429px;left:145px;" src="/2025/static/_content/63-icon-8.png"/>
        <img class="abs halfScaleC 63-text-2" style="top:484px;left:129px;" src="/2025/static/_content/63-text-9.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:506px;left:138px; font-size: 1.18em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 19.3, "decimals" : 1, "append" : "m"}' ></h1>

        <img class="abs halfScaleC 63-icon-2" style="top:529px;left:121px;" src="/2025/static/_content/63-icon-9.png"/>
        <img class="abs halfScaleC 63-text-2" style="top:574px;left:96px;" src="/2025/static/_content/63-text-10.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:618px;left:141px; font-size: 1.18em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 950, "append" : "k"}' ></h1>

        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:468px;left:240px; font-size: 1.18em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 564.6, "decimals" : 1, "append" : "k"}' ></h1>
        <img class="abs halfScaleC 63-icon-2" style="top:483px;left:238px;" src="/2025/static/_content/63-icon-10.png"/>
        <img class="abs halfScaleC 63-text-2" style="top:534px;left:218px;" src="/2025/static/_content/63-text-11.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:579px;left:242px; font-size: 1.18em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 363.5, "decimals" : 1, "append" : "k"}' ></h1>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:601px;left:248px; font-size: 1em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 12, "preppend" : "(+", "append" : "%)"}' ></h1>
        <img class="abs halfScaleC 63-line-vert-2" style="top:437px;left:336px;" src="/2025/static/_content/63-line-1.png"/>
        <img class="abs halfScaleC 63-icon-2" style="top:483px;left:356px;" src="/2025/static/_content/63-icon-11.png"/>
        <img class="abs halfScaleC 63-text-2" style="top:541px;left:361px;" src="/2025/static/_content/63-text-12.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:577px;left:367px; font-size: 1.18em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 15.8, "decimals" : 1, "append" : "k"}' ></h1>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:599px;left:363px; font-size: 1em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 64, "preppend" : "(+", "append" : "%)"}' ></h1>

        <img class="abs halfScaleC 63-line-vert-2" style="top:437px;left:448px;" src="/2025/static/_content/63-line-1.png"/>
        <img class="abs halfScaleC 63-icon-2" style="top:483px;left:473px;" src="/2025/static/_content/63-icon-12.png"/>
        <img class="abs halfScaleC 63-text-2" style="top:541px;left:436px;" src="/2025/static/_content/63-text-13.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:577px;left:481px; font-size: 1em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 23, "preppend" : "(+", "append" : "%)"}' ></h1>

        
        <!-- section three -->

        <img class="abs halfScaleC 63-line-3" style="top:664px;left:-186px;" src="/2025/static/_content/63-line-long-1.png"/>

        <img class="abs halfScaleC 63-sm-icon-3" style="top:680px;left:45px;" src="/2025/static/_content/63-icon-13.png"/>
        <img class="abs halfScaleC 63-sm-text-3" style="top:745px;left:3px;" src="/2025/static/_content/63-text-14.png"/>
        <img class="abs halfScaleC 63-icon-3" style="top:694px;left:116px;" src="/2025/static/_content/63-icon-16.png"/>
        <img class="abs halfScaleC 63-text-3" style="top:748px;left:115px;" src="/2025/static/_content/63-text-17.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:773px;left:149px; font-size: 1.18em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 575, "append" : "k"}' ></h1>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:796px;left:148px; font-size: 0.9em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 23, "preppend" : "(+", "append" : "%)"}' ></h1>
        <img class="abs halfScaleC 63-line-vert-3" style="top:630px;left:216px;" src="/2025/static/_content/63-line-1.png"/>

        <img class="abs halfScaleC 63-sm-icon-3" style="top:680px;left:228px;" src="/2025/static/_content/63-icon-14.png"/>
        <img class="abs halfScaleC 63-sm-text-3" style="top:744px;left:199px;" src="/2025/static/_content/63-text-15.png"/>
        <img class="abs halfScaleC 63-icon-3" style="top:694px;left:293px;" src="/2025/static/_content/63-icon-16.png"/>
        <img class="abs halfScaleC 63-text-3" style="top:748px;left:292px;" src="/2025/static/_content/63-text-17.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:773px;left:337px; font-size: 1.18em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 7, "append" : "k"}' ></h1>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:796px;left:325px; font-size: 0.9em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 23, "preppend" : "(+", "append" : "%)"}' ></h1>
        <img class="abs halfScaleC 63-line-vert-3" style="top:630px;left:397px;" src="/2025/static/_content/63-line-1.png"/>

        <img class="abs halfScaleC 63-sm-icon-3" style="top:679px;left:413px;" src="/2025/static/_content/63-icon-15.png"/>
        <img class="abs halfScaleC 63-sm-text-3" style="top:746px;left:376px;" src="/2025/static/_content/63-text-16.png"/>
        <img class="abs halfScaleC 63-icon-3" style="top:694px;left:481px;" src="/2025/static/_content/63-icon-16.png"/>
        <img class="abs halfScaleC 63-text-3" style="top:748px;left:481px;" src="/2025/static/_content/63-text-17.png"/>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:773px;left:522px; font-size: 1.18em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 2, "append" : "m"}' ></h1>
        <h1 id="63-no" class="abs montAlternatesBd 63-no" style="top:796px;left:510px; font-size: 0.9em; font-weight: 300; color: #b4ce46; padding: 0px; margin: 0px;"  data-number='{"to": 133, "preppend" : "(+", "append" : "%)"}' ></h1>


        <!-- emojis -->

        <img class="abs halfScaleC 63-socials" style="top:366px;left:220px;" src="/2025/static/_content/63-socials-2.png"/>
        <img class="abs halfScaleC 63-socials" style="top:35px;left:205px;" src="/2025/static/_content/63-socials-3.png"/>
        <img class="abs halfScaleC 63-socials" style="top:776px;left:21px;" src="/2025/static/_content/63-socials-4.png"/>
        <img class="abs halfScaleC 63-socials" style="top:418px;left:502px;" src="/2025/static/_content/63-socials-5.png"/>
        <img class="abs halfScaleC 63-socials" style="top:21px;left:75px;" src="/2025/static/_content/63-socials-6.png"/>
        <img class="abs halfScaleC 63-socials" style="top:74px;left:380px;" src="/2025/static/_content/63-socials-7.png"/>
        <img class="abs halfScaleC 63-socials" style="top:624px;left:329px;" src="/2025/static/_content/63-socials-8.png"/>
        <img class="abs halfScaleC 63-socials" style="top:309px;left:53px;" src="/2025/static/_content/63-socials-9.png"/>
        <img class="abs halfScaleC 63-socials" style="top:567px;left:506px;" src="/2025/static/_content/63-socials-10.png"/>
        <img class="abs halfScaleC 63-socials" style="top:251px;left:24px;" src="/2025/static/_content/63-socials-11.png"/>
        <img class="abs halfScaleC 63-socials" style="top:771px;left:224px;" src="/2025/static/_content/63-socials-12.png"/>
        <img class="abs halfScaleC 63-socials" style="top:571px;left:42px;" src="/2025/static/_content/63-socials-13.png"/>


        <!-- links -->

        <div class="addContentLink" style="top:82px;left:418px;width:187px;height:348px;">
          <a href="https://www.tiktok.com/@figymnastics/video/7564690988288052502?_r=1&_t=ZN-933Cn0Yx4lS" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:115px;left:58px;width:51px;height:48px;border-radius:50%;">
          <a href="https://www.tiktok.com/@figymnastics" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:432px;left:62px;width:51px;height:48px;border-radius:50%;">
          <a href="https://www.youtube.com/user/figchannel" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:696px;left:62px;width:51px;height:48px;border-radius:50%;">
          <a href="https://www.instagram.com/figymnastics" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:696px;left:244px;width:51px;height:48px;border-radius:50%;">
          <a href="https://www.linkedin.com/company/worldgymnastics/" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:696px;left:430px;width:51px;height:48px;border-radius:50%;">
          <a href="https://www.facebook.com/WorldGymnasticsOfficial" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:444px;left:245px;width:58px;height:22px;">
          <a href="https://www.youtube.com/@gymnasticschannel/shorts" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          pg63Anim = new TimelineMax();
          pg63Anim.fromTo(cOf("63-sm-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)
          .fromTo(cOf("63-sm-text"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)

          .staggerFromTo(cOf("63-icon"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)
          .staggerFromTo(cOf("63-text"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.5)
          .fromTo(cOf("63-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[0])}}, 1.7)
          .fromTo(cOf("63-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[1])}}, 1.7)
          .staggerFromTo(cOf("63-line-vert"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.6)
          .fromTo(cOf("63-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[2])}}, 1.8)
          .fromTo(cOf("63-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[3])}}, 1.8)
          .fromTo(cOf("63-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[4])}}, 2)
          .fromTo(cOf("63-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[5])}}, 2.1)
          .fromTo(cOf("63-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[6])}}, 2.2)
          .fromTo(cOf("63-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[7])}}, 2.3)
          .staggerFromTo(cOf("63-line"), 0.5, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.5, 2.4)
          .fromTo(cOf("63-text-arrow"), 0.5, {opacity:0, x: -20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.6)
          .staggerFromTo(cOf("63-image"), 0.6, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 2.9)

          .fromTo(cOf("63-sm-icon-2"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3)
          .fromTo(cOf("63-sm-text-2"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.1)
          .staggerFromTo(cOf("63-icon-2"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 3.3)
          .staggerFromTo(cOf("63-text-2"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 3.4)

          .fromTo(cOf("63-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[8])}}, 3.5)
          .fromTo(cOf("63-no")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[9])}}, 3.6)

          .fromTo(cOf("63-box"), 0.6, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.8)
          .fromTo(cOf("63-no")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[10])}}, 4)
          .fromTo(cOf("63-no")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[11])}}, 4.1)
          .fromTo(cOf("63-no")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[12])}}, 4.1)

          .staggerFromTo(cOf("63-line-vert-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 4.2)
          .fromTo(cOf("63-no")[13], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[13])}}, 4.4)
          .fromTo(cOf("63-no")[14], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[14])}}, 4.4)
          .fromTo(cOf("63-no")[15], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[15])}}, 4.5)

          .fromTo(cOf("63-line-3"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 4.6)
          .staggerFromTo(cOf("63-sm-icon-3"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 4.8)
          .staggerFromTo(cOf("63-sm-text-3"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.3, 5)
          .staggerFromTo(cOf("63-icon-3"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 5.2)
          .staggerFromTo(cOf("63-text-3"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.3, 5.3)

          .fromTo(cOf("63-no")[16], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[16])}}, 5.4)
          .fromTo(cOf("63-no")[17], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[17])}}, 5.4)

          .staggerFromTo(cOf("63-line-vert-3"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 5.5)

          .fromTo(cOf("63-no")[18], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[18])}}, 5.6)
          .fromTo(cOf("63-no")[19], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[19])}}, 5.6)
          .fromTo(cOf("63-no")[20], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[20])}}, 5.9)
          .fromTo(cOf("63-no")[21], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("63-no")[21])}}, 5.9)

          .staggerFromTo(cOf("63-socials"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 6.1);

          setTimeout(function(){
            addContentLinks();
          },7000)
        }

        function onPageLeave() {
          pg63Anim.stop();
          resetNumbers("63-no");
          removeContentLinks();
        }
      `,
      "searchText": "Fan engagement  Media and Marketing  figymnasti  TikTok  Engaged audience  Reached audience  Likes  2.6m  35m  6.6m  Comments  Followers  One of the top posts  96k  134.1k  (+150%)  (+158%)  (+221%)  cs  Jake Jarman 43.9k likes username  Shorts  YouTube  Views  564.6k  19.3m Engaged views Hours of watch time  950k  Instagram  Followers  575k  (+23%)  363.5k  Subscribers  15.8k  (+23%)  (+64%)  (+12%)  LinkedIn  Likes  Followers  7k  (+23%)  Facebook Followers  2m  (+133%) WORLD GYMNASTICS YEARBOOK 2025  63"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 63,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg64.jpg",
      "zoom": null,
      "content": `
      
        <img class="abs halfScaleC 64-line" style="top:240px;left:177px;" src="/2025/static/_content/64-line-1.png"/>
        <img class="abs halfScaleC 64-line-sm" style="top:414px;left:201px;" src="/2025/static/_content/64-line-2.png"/>
        <img class="abs halfScaleC 64-line-sm" style="top:523px;left:213px;" src="/2025/static/_content/64-line-3.png"/>
        <img class="abs halfScaleC 64-line-sm" style="top:629px;left:238px;" src="/2025/static/_content/64-line-4.png"/>
        <img class="abs halfScaleC 64-line-sm" style="top:705px;left:237px;" src="/2025/static/_content/64-line-5.png"/>
        <img class="abs halfScaleC 64-line-sm" style="top:736px;left:313px;" src="/2025/static/_content/64-line-6.png"/>

        <img class="abs halfScaleC 64-text" style="top:363px;left:122px;" src="/2025/static/_content/64-text-1.png"/>
        <img class="abs halfScaleC 64-text" style="top:473px;left:85px;" src="/2025/static/_content/64-text-2.png"/>
        <img class="abs halfScaleC 64-text" style="top:582px;left:93px;" src="/2025/static/_content/64-text-3.png"/>
        <img class="abs halfScaleC 64-text" style="top:644px;left:90px;" src="/2025/static/_content/64-text-4.png"/>
        <img class="abs halfScaleC 64-text" style="top:709px;left:138px;" src="/2025/static/_content/64-text-5.png"/>

        <img class="abs halfScaleC 64-icon" style="top:292px;left:-12px;" src="/2025/static/_content/64-icon-1.png"/>
        <img class="abs halfScaleC 64-icon" style="top:487px;left:24px;" src="/2025/static/_content/64-icon-2.png"/>
        <img class="abs halfScaleC 64-icon" style="top:576px;left:56px;" src="/2025/static/_content/64-icon-3.png"/>
        <img class="abs halfScaleC 64-icon" style="top:652px;left:85px;" src="/2025/static/_content/64-icon-4.png"/>
        <img class="abs halfScaleC 64-icon" style="top:733px;left:130px;" src="/2025/static/_content/64-icon-5.png"/>

        <h1 id="64-no" class="abs montAlternatesExBd 64-no" style="top:457px;left:60px; font-size: 1.15em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 119, "preppend" : "(+", "append" : "%)"}' ></h1>
        <h1 id="64-no" class="abs montAlternatesExBd 64-no" style="top:515px;left:120px; font-size: 1.15em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 670, "append" : " hours"}' ></h1>
        <h1 id="64-no" class="abs montAlternatesExBd 64-no" style="top:619px;left:137px; font-size: 1.15em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 252, "append" : " million"}' ></h1>
        <h1 id="64-no" class="abs montAlternatesExBd 64-no" style="top:697px;left:152px; font-size: 1.15em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 28, "append" : " markets"}' ></h1>
        <h1 id="64-no" class="abs montAlternatesExBd 64-no" style="top:757px;left:207px; font-size: 1.15em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 114, "append" : " markets"}' ></h1>

        <div class="addContentLink" style="top:787px;left:205px;width:131px;height:18px;">
          <a href="https://eurovisionsport.com/fr/explore/sports/gymnastics?filter=past" target="_blank"></a>
        </div>

        <a href="https://www.worldgymnastics.tv/en" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:724px;left:14px;" src="/2025/static/_content/btn-tv-solid.png">
        </a>

      `,
      "script": `
        function onPageEnter() {
          pg64Anim = new TimelineMax();
          pg64Anim.fromTo(cOf("64-line"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("64-line-sm"), 0.5, {opacity:0, x: -20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.1)
          .staggerFromTo(cOf("64-text"), 0.5, {opacity:0, x: -25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.2)
          .staggerFromTo(cOf("64-icon"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.3)
           .fromTo(cOf("64-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("64-no")[0])}}, 1.8)
           .fromTo(cOf("64-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("64-no")[1])}}, 1.9)
           .fromTo(cOf("64-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("64-no")[2])}}, 2)
           .fromTo(cOf("64-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("64-no")[3])}}, 2.1)
           .fromTo(cOf("64-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("64-no")[4])}}, 2.2)

           setTimeout(function(){
            addContentLinks();
          },7000)
        }

        function onPageLeave() {
          pg64Anim.stop();
          resetNumbers("64-no");
          removeContentLinks();
        }
      `,
      "searchText": "Media and Marketing  TV  How the world saw Jakarta 2025 In addition to the passionate local crowds in Indonesia, the 53rd FIG Artistic Gymnastics World Championships were viewed by millions across the globe.  2023 2025  (+119%)  More than doubled viewer hours compared with the 2023 edition  More than  670 hours of coverage aired globally  Total global TV audience of over  252 million Coverage was aired on linear TV (free-to-air) in  28 markets globally  Live coverage available in  114 markets  around the world via the eurovisionsports.com platform  64  WORLD GYMNASTICS YEARBOOK 2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 64,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg65.jpg",
      "zoom": null,
      "content": `

        <div class="contentLink" style="top:828px;left:145px;width:202px;height:22px">
          <a href="https://www.americanathletic.com" target="_blank"></a>
        </div>

      `,
      "script": `
       function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 65,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg66.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Media and Marketing  Fujitsu  Fujitsu Infinity Award winners 2025 Each year, the Fujitsu Infinity Award honours one men’s and one women’s team, celebrating the values of innovation, precision and human achievement that unite technology and sport.  A  t the 53rd Artistic Gymnastics World Championships in Jakarta, Indonesia, a joint World Gymnastics-Fujitsu jury selected the winners, choosing from among the most successful federations at the event, highlighting those whose gymnasts stood out through results, artistry and team spirit. This year, the USA women’s team and the Japan men’s team were the  66  WORLD GYMNASTICS YEARBOOK 2025  recipients of the awards, with each receiving a trophy and a cash prize of USD 10,000, shared among the athletes who contributed to these achievements. The presentation took place on Friday 24 October, following the Men’s Floor Exercise and Women’s Vault finals, in the presence of President Morinari Watanabe and Naoko Otsuka, EVP, Global Solutions Business Group, Fujitsu Ltd."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 66,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg67.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:820px;left:355px;width:160px;height:18px">
          <a href="https://www.gymnova.com" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "NEW!  NEW!  NOUVEATILLOEN GÉNÉR  INFLATABLE PIT  NEW GENERATION  Maximum height: 1,35 m  Ref. 7196  Design©2024 zen-studio.com  Standard height: 20 cm  CONFIDENCE Learning without apprehension  GYMNOVA revolutionizes your training with custom-made inflatable pits.  VERSATILITY Quick adjustments of pressure and height  These pits are ideal for all gymnastic acrobatic landings and provide the same cushioning performance as traditional pits.  COMFORT 20 cm jersey mat  Choose performance and safety with GYMNOVA !  SAFETY 20 cm foam in case of a power cut  www.gymnova.com"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 67,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg68.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 68,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg69.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "INSTITUTIONAL"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 69,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg70.jpg",
      "zoom": null,
      "content": `
      
        <div class="addContentLink" style="top:278px;left:81px;width:80px;height:12px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4410910" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Institutional  Transfer of Power  Transfer of Power welcomes new authorities The ceremony was held at the Olympic Museum in Lausanne in February.  H  eld every four years to usher in a new Olympic cycle, the Transfer of Power ceremony is the time when all the newly elected authorities of World Gymnastics are officially sworn in. This includes every elected position: President, Vice-Presidents, Executive Committee members, Technical Committee members and Auditors. Several officials were re-elected to their positions, including President Morinari Watanabe (JPN), as well as Vice-Presidents Ali Al-Hitmi (QAT) and Suat Celen (TUR).  70  WORLD GYMNASTICS YEARBOOK 2025  Newly elected authorities included Naomi Valenzo (MEX) as Vice-President, and Andrew Tombs (GBR) and Nikolina Hristova (BUL) as the Technical Committee Presidents of Men’s Artistic Gymnastics and Acrobatic Gymnastics respectively. It is also a chance to thank outgoing authorities for their services to the sport. Outgoing officials Nellie Kim (BLR), Arturs Mickevics (LAT) and Rosy Taeymans (BEL) were all awarded bronze and silver distinctions as well as honorary vicepresident titles in recognition of their outstanding contributions to gymnastics.  Pictured Executive Committee members at the ceremony"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 70,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg71.jpg",
      "zoom": null,
      "content": `
      
        <div class="addContentLink" style="top:638px;left:297px;width:45px;height:12px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4455707" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Executive Committee and Council  Institutional  Pictured Council meeting in Qawra (MLT)  Executive Committee and Council meetings: key points Outcomes from Executive Committee and Council meetings, including major decisions and approvals.  Executive Committee  Council  The Executive Committee met four times during the year. Key decisions included the re-appointment of Nicolas Buompane as Secretary General, and the confirmation of the Commissions and Working Groups for the 2025-2028 cycle.  This year’s Council meeting was held in Qawra, Malta. The Council approved the qualification systems for Men’s and Women’s Artistic, Rhythmic and Trampoline & Tumbling for the 2028 Olympic Games in Los Angeles (USA). It also approved the provisional affiliation of the gymnastics federations of Belize and Timor-Leste, to be ratified at the 2026 Congress.  WORLD GYMNASTICS YEARBOOK 2025  71"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 71,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg72.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Institutional  NF Connect  NF Connect: bridging conversations In 2025, a new project called NF Connect was introduced, covering five sessions throughout the year.  A  new informative and interactive platform aims to initiate dialogue and foster exchange between national federations (NFs), relevant stakeholders and World Gymnastics. NF Connect sessions are held online every two months and are also made available for download on the Intranet.  Five sessions took place in 2025 1. From floor to score: A practical guide to music copyright in gymnastics for athletes, NFs and Local Organising Committees (speaker: ClicknClear*) 2. Inside coaching & athlete licensing: An overview of World Gymnastics programmes (speaker: Education Department) 3. S ocial media tips & tricks: Engaging the gymnastics community (speaker: Communications Department) 4. Championing safeguarding: NFs’ unique safe sport journeys (speaker: Safeguarding Department) 5. Marketing insights: Shaping the future of our sport (speaker: Marketing department) The project will continue in 2026, maintaining the same format. *Music licensing platform  72  WORLD GYMNASTICS YEARBOOK 2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 72,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg73.jpg",
      "zoom": null,
      "content": `
      
        <div class="addContentLink" style="top:518px;left:64px;width:144px;height:17px;">
          <a href="https://www.stv-fsg.ch/fr/news/artikel/linclusivite-au-coeur-de-la-fsg/" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "NF Insights | Institutional  NF Insights: highlights from our members The NF Insights programme is helping World Gymnastics build a better picture of the sport.  S  ince its launch in 2024, NF Insights has helped World Gymnastics better understand its member federations through data collection, monitoring strategic directions, enhancing communication channels and tracking governance standards. Here is an overview of key developments across the gymnastics community within the continental unions.  Africa: Sierra Leone  Asia: Afghanistan  The federation participated in the 2nd Baku Gym for All International Challenge in Azerbaijan, making their debut at the event. The participants were also awarded several gold awards at the event across multiple categories.  Despite economic challenges and limited funding, the Afghanistan National Gymnastics Federation held two national competitions in 2025, with more than 300 gymnasts competing across the two events in Kabul.  Europe: Switzerland The 77th Swiss Gymnastics Festival, held in June in Lausanne, marked a major milestone for inclusion in Swiss gymnastics. For the first time, athletes with and without disabilities competed together. Rules and scoring systems  were adapted to ensure fair participation, the federation partnered with PluSport to organise seven inclusive competitions and universal accessibility was prioritised with barrier-free facilities, inclusive communication and trained volunteers.  Oceania: Cook Islands  Pan America: Brazil  The federation created professional development opportunities for coaches, with an international expert delivering a ‘coach the coaches’ upskilling session. They also introduced a Parkour programme for the first time, giving local children a taste of the sport.  Following a historic performance at the Paris 2024 Olympic Games, the Brazilian Gymnastics Federation hosted the Rhythmic Gymnastics World Championships for the first time in Rio de Janeiro.  WORLD GYMNASTICS YEARBOOK 2025  73"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 73,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg74.jpg",
      "zoom": null,
      "content": `

        <img class="abs halfScaleC 74-quote" style="top:636px;left:-39px;" src="/2025/static/_content/74-quote-1.png"/>          
        <img class="abs halfScaleC 74-quote" style="top:631px;left:203px;" src="/2025/static/_content/74-quote-2.png"/>
        <img class="abs halfScaleC 74-quote" style="top:698px;left:-38px;" src="/2025/static/_content/74-quote-3.png"/>     
        <img class="abs halfScaleC 74-quote" style="top:709px;left:202px;" src="/2025/static/_content/74-quote-4.png"/>
        
        <div class="addContentLink" style="top:504px;left:166px;width:46px;height:12px;">
          <a href="https://www.gymnastics.sport/site/pages/safeguarding-goldenrules.php" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:514px;left:52px;width:93px;height:12px;">
          <a href="https://www.gymnastics.sport/site/pages/safeguarding-goldenrules.php" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg74Anim = new TimelineMax();
          pg74Anim.staggerFromTo(cOf("74-quote"), 0.7, {opacity:0, x: 35}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg74Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Institutional  Safeguarding  Honouring commitment, building the future The year 2025 marked the retirement of Eunice Lebre, who played an instrumental role in the implementation of safeguarding measures in World Gymnastics.  A  former gymnast and coach, Eunice Lebre devoted her life to the sport and to the well-being of those who practise it. Over the years, she served in several capacities, including Sport Manager and later Safeguarding Manager, bringing dedication, experience and a deep understanding of athletes’ needs to her work. Among her contributions, Lebre played an instrumental role in coordinating the first Athletes’ Safeguarding Working Group. In 2021, this group developed the 10 Golden Rules of Gymnastics, an initiative reflecting a shared commitment across generations to protecting young athletes, prioritising both mental and physical health and  Pictured Eunice Lebre  fostering a culture grounded in respect and dignity. Lebre was also closely involved in implementing the Safeguarding Officer role at international competitions, working with Local Organising Committees to ensure safeguarding procedures became integral to event operations, and supported the Safeguarding Commission in its initiatives. As we thank Lebre for her dedication and long-standing contribution to the sport, we also recognise that safeguarding is, above all, a collective and continuous effort.  VOICES FROM THE COMMUNITY In the spirit of continuity, former athletes who are now coaches shared a phrase from their own mentors that stayed with them throughout their careers.  “You are your best coach.” A reminder to understand my mind, my body and my goals – learning when to push forward and when to rest, while enjoying the journey. Elsa García, OLY (Mexico) “Coaching is more than instruction; it’s dedication, belief and going beyond what’s expected. The coaches who give their full energy are the ones who truly shape athletes’ lives.” Alexandra Kiroi-Bogatyreva, OLY (Australia)  74  WORLD GYMNASTICS YEARBOOK 2025  “Results are a byproduct.” A principle that reminds me that the athlete’s well-being is always the first priority, guiding me to put people first and create an environment where athletes feel safe and respected. Hiroaki Sato (Japan) “Consistency, respect and care create real performance and the person behind it.” A reflection of my belief that structured work in a safe and supportive environment leads to lasting success in sport and in life. Aljaz Pegan (Slovenia)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 74,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg75.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:824px;left:45px;width:154px;height:18px">
          <a href="https://www.pastorellisport.com" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }

      `,
      "searchText": "Professional sportswear and equipment supplier  pastorellisport.com"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 75,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg76.jpg",
      "zoom": null,
      "content": `
      
        <img class="abs halfScaleC 76-title" style="top:223px;left:-43px;" src="/2025/static/_content/76-title-1.png"/>
        <img class="abs halfScaleC 76-sub" style="top:308px;left:-62px;" src="/2025/static/_content/76-sub-1.png"/>

        <img class="abs halfScaleC 76-text" style="top:495px;left:-45px;" src="/2025/static/_content/76-text-1.png"/>
        <img class="abs halfScaleC 76-icon" style="top:530px;left:40px;" src="/2025/static/_content/76-icon-1.png"/>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:525px;left:105px; font-size: 4.75em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 1040}' ></h1>

        <img class="abs halfScaleC 76-text" style="top:619px;left:87px;" src="/2025/static/_content/76-text-2.png"/>
        <img class="abs halfScaleC 76-text" style="top:600px;left:-55px;" src="/2025/static/_content/76-line-1.png"/>
        <img class="abs halfScaleC 76-icon-1" style="top:636px;left:101px;" src="/2025/static/_content/76-icon-2.png"/>
        <img class="abs halfScaleC 76-icon-1" style="top:637px;left:190px;" src="/2025/static/_content/76-icon-3.png"/>
        <img class="abs halfScaleC 76-text" style="top:704px;left:-55px;" src="/2025/static/_content/76-line-2.png"/>
        <img class="abs halfScaleC 76-text" style="top:745px;left:15px;" src="/2025/static/_content/76-text-3.png"/>

        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:707px;left:110px; font-size: 1.2em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 922}' ></h1>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:707px;left:213px; font-size: 1.2em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 118}' ></h1>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:796px;left:109px; font-size: 1.2em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 574}' ></h1>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:796px;left:204px; font-size: 1.2em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 466}' ></h1>

        <img class="abs halfScaleC 76-vert-line" style="top:124px;left:305px;" src="/2025/static/_content/76-line-3.png"/>
        <img class="abs halfScaleC 76-text-2" style="top:351px;left:233px;" src="/2025/static/_content/76-text-4.png"/>
        <img class="abs halfScaleC 76-icon-2" style="top:383px;left:304px;" src="/2025/static/_content/76-icon-4.png"/>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:386px;left:386px; font-size: 4.75em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 986}' ></h1>
        <img class="abs halfScaleC 76-pie" style="top:410px;left:308px;" src="/2025/static/_content/76-pie-1.png"/>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:535px;left:327px; font-size: 1.15em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 39, "append" : "%"}' ></h1>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:535px;left:516px; font-size: 1.15em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 61, "append" : "%"}' ></h1>
     
        <img class="abs halfScaleC 76-text-2" style="top:554px;left:238px;" src="/2025/static/_content/76-text-5.png"/>
        <img class="abs halfScaleC 76-icon-3" style="top:613px;left:313px;" src="/2025/static/_content/76-icon-5.png"/>
        <img class="abs halfScaleC 76-text-3" style="top:621px;left:328px;" src="/2025/static/_content/76-text-6.png"/>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:658px;left:365px; font-size: 1.15em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 716}' ></h1>
        <img class="abs halfScaleC 76-icon-3" style="top:623px;left:439px;" src="/2025/static/_content/76-icon-6.png"/>
        <img class="abs halfScaleC 76-text-3" style="top:621px;left:463px;" src="/2025/static/_content/76-text-7.png"/>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:648px;left:494px; font-size: 1.15em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 69}' ></h1>

        <img class="abs halfScaleC 76-text-3" style="top:697px;left:212px;" src="/2025/static/_content/76-line-4.png"/>
        <img class="abs halfScaleC 76-text-3" style="top:703px;left:245px;" src="/2025/static/_content/76-text-8.png"/>
        <img class="abs halfScaleC 76-icon-3" style="top:742px;left:296px;" src="/2025/static/_content/76-icon-7.png"/>
        <img class="abs halfScaleC 76-text-3" style="top:750px;left:367px;" src="/2025/static/_content/76-text-9.png"/>
        <h1 id="76-no" class="abs montAlternatesSemiBd 76-no" style="top:796px;left:426px; font-size: 1.2em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 1}' ></h1>

        <div class="addContentLink" style="top:367px;left:174px;width:109px;height:12px;">
          <a href="https://ita.sport/?s=gymnastics" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:381px;left:57px;width:69px;height:12px;">
          <a href="https://ita.sport/?s=gymnastics" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg76Anim = new TimelineMax();
          pg76Anim.staggerFromTo(cOf("76-text"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.3, 1)
          .fromTo(cOf("76-icon"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)
          .fromTo(cOf("76-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[0])}}, 1.4)
          .staggerFromTo(cOf("76-icon-1"), 0.5, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.3, 1.6)
          .fromTo(cOf("76-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[1])}}, 1.9)
          .fromTo(cOf("76-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[2])}}, 1.9)
          .fromTo(cOf("76-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[3])}}, 2.2)
          .fromTo(cOf("76-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[4])}}, 2.2)
     
          .fromTo(cOf("76-vert-line"), 0.5, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2)
          .staggerFromTo(cOf("76-text-2"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.4, 2.4)
          .fromTo(cOf("76-icon-2"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.6)
          .fromTo(cOf("76-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[5])}}, 2.8)
          .fromTo(cOf("76-pie"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3)
          .fromTo(cOf("76-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[6])}}, 3.2)
          .fromTo(cOf("76-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[7])}}, 3.2)
          .staggerFromTo(cOf("76-icon-3"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 3.4)
          .staggerFromTo(cOf("76-text-3"), 0.5, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 3.6)
          .fromTo(cOf("76-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[8])}}, 3.8)
          .fromTo(cOf("76-no")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[9])}}, 3.8)
          .fromTo(cOf("76-no")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("76-no")[10])}}, 4.6)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg76Anim.stop();
          resetNumbers("76-no");
          removeContentLinks();
        }
      `,
      "searchText": "Institutional | Medical  Promoting clean sport World Gymnastics enjoyed a successful year collaborating with the International Testing Agency (ITA). The ITA provides a range of antidoping services to World Gymnastics, such as sample collection and results management as well as providing live dashboards that allow the federation to monitor its anti-doping activities throughout the year.  TOTAL COMPLETED TESTS  986  TOTAL SAMPLES COLLECTED  1040  39%  61%  men  women  TYPE OF SAMPLE  Urine  Blood  922  118  Samples collected IN competition  Samples collected OUT OF competition  574  76  WORLD GYMNASTICS YEARBOOK 2025  466  Samples collected from  716 athletes ANTI-DOPING RULE VIOLATIONS (ADRVS) Confirmed and sanction imposed  1  representing  69 nationalities"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 76,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg77.jpg",
      "zoom": null,
      "content": `

        <div class="contentLink" style="top:754px;left:204px;width:66px;height:66px">
          <a href="https://cn.linkedin.com/company/taishan-sports-equipment" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:754px;left:286px;width:66px;height:66px">
          <a href="https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2FTaishanSports.cn%2F" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:754px;left:369px;width:66px;height:66px">
          <a href="https://www.instagram.com/taishansports/" target="_blank"></a>
        </div>
        
        <div class="contentLink" style="top:830px;left:228px;width:176px;height:18px">
          <a href="https://www.taishansports.cn" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 77,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg78.jpg",
      "zoom": null,
      "content": `
      
        <a href="https://www.youtube.com/@figeducationchannel2014" target="_blank">
          <img class="abs halfpulse animatedpulse halfScaleC pointer" style="top:394px;left:14px;" src="/2025/static/_content/btn-play-black.png">
        </a>

        <a href="https://elearning.gymnastics.sport/" target="_blank">
          <img class="abs halfScaleC pointer" style="top:738px;left:335px;" src="/2025/static/_content/78-btn-dark-1.png">
        </a>

      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Institutional  Education  Helping youngsters achieve Olympic goal World Gymnastics has supported an initiative to boost gymnasts’ hopes of participating in the Youth Olympic Games in Dakar.  A  s part of a new development initiative, World Gymnastics’ Education Department supported a series of Artistic training camps in places far and wide in 2025. The programme, titled the Youth Athlete Development (YAD) project, is designed to strengthen the technical preparation of athletes, enhance competitive performance, and promote the participation of athletes and teams from different countries in the Youth Olympic Games (YOG) Dakar 2026. It involved a series of five-day camps, organised in close co-operation with the Olympic Solidarity programme and hosted by national federations.  78  WORLD GYMNASTICS YEARBOOK 2025  The project offered an opportunity for World Gymnastics experts to assess the skill levels of gymnasts and coaches. In the case of gymnasts, this meant identifying youngsters with the potential to meet qualifying standards. For coaches, it meant finding those with the necessary methodologies and training techniques. The overall aim was to support the technical preparation of young athletes from developing nations, ensuring the provision of training plans to improve their technical level and performance and achieve higher scores in competitions at the YOG, to be held from 31 October to 13 November 2026."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 78,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg79.jpg",
      "zoom": null,
      "content": `

        <div class="contentLink" style="top:469px;left:527px;width:38px;height:13px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4678259" target="_blank"></a>
        </div>
        <div class="contentLink" style="top:480px;left:452px;width:38px;height:13px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4678259" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:646px;left:267px;width:249px;height:18px">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4394929" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Education  Institutional  All ears as coaches have their say  Across the continents The first development camp in 2025 was for Women’s Artistic and took place in Guatemala City (GUA) from 22-31 May, led by expert Rhony Ferreira (BRA). It involved 14 gymnasts, aged 14, and their training sessions were carefully planned to optimise performance ahead of the Pan-American Artistic Gymnastics Championships in Panama in June. That set the template for subsequent camps held between June and August in Tunis (TUN), Vilnius (LTU), Amman (JOR) and Algiers (ALG) – the first two for Men’s Artistic and the second two for Women’s Artistic. The year closed with two further camps – in Dhaka (BAN) in November and in Riga (LAT) in December. How it worked To be eligible for the YAD camps, Men’s Artistic participants had to have been born between 1 January 2009 and 31 December 2011, while for Women’s Artistic it was between 1 January 2011 and 31 December 2011.  Pictured YAD participants in Guatemala  Participants had to demonstrate the potential to improve their technical level and gain higher scores in competitions.  The World Gymnastics website launched a series of monthly in-depth interviews with coaches, experts and educators from around the world, titled ‘Behind the Mat’, in which they reflected on their careers, discussed the state of gymnastics in their home countries – including the challenges faced in their local contexts – and offered broader reflections on the future of the sport.  Australia stages ‘Mega Academy’ Of all the academies staged in 2025, none was bigger than the Level 1 Multi-Discipline Academy in Canberra (AUS). Held from 20-24 January, it encompassed six disciplines and involved 139 coaches, 18 expert presenters, 32 gymnast demonstrators and nine chaperones from two countries (AUS and NZL) and seven Australian states. Jorge Mendez (ESP) acted as course leader. The academy took place across three venues: the Australian Institute of Sport (AIS) for Men’s and Women’s Artistic and Aerobics sessions; Tuggeranong Multisport Facility for Rhythmic and Trampoline & Tumbling; and Gungahlin Gymnastics for Acrobatics.  WORLD GYMNASTICS YEARBOOK 2025  79"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 79,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg80.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Institutional  Academies  Global gymnastics A continent-by-continent breakdown of the year’s Academies, Age Group camps, Olympic Solidarity courses and Youth Athlete Development projects.  ACADEMIES  AGE GROUP CAMPS  Africa  Africa  Egypt (RG, AER)  Kenya (WAG)  Africa  South Africa (RG)  Madagascar (PK)  Cameroon (WAG)  Americas  Mauritius (WAG)  Guinea (MAG)  Costa Rica (GfA, MAG & WAG)  Zambia (ACRO)  Sierra Leone (RG)  Ecuador (T&T)  Americas  Asia  Panama (AER)  Canada (PK)  Kazakhstan (T&T)  Paraguay (GfA, RG)  Asia  Mongolia (RG)  Mexico (RG)  Uzbekistan (GfA)  Asia  Europe  Japan (MAG & WAG)  Estonia (PK)  Mongolia (RG)  Latvia (RG)  Thailand (RG)  Oceania Australia (MAG & WAG, RG, T&T, AER, ACRO)  80  WORLD GYMNASTICS YEARBOOK 2025  OLYMPIC SOLIDARITY COURSES  Tajikistan (T&T) Uzbekistan (MAG)  YOUTH ATHLETE DEVELOPMENT PROJECTS Africa Algeria (WAG) Cameroon (WAG) Kenya (WAG) Tunisia (MAG)  Americas Guatemala (WAG)  Asia Bangladesh (MAG) Jordan (WAG)  Europe Latvia (WAG) Lithuania (MAG)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 80,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg81.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC 81-box" style="top:415px;left:-214px;" src="/2025/static/_content/81-box-1.png"/>

      <!-- icons and numbers -->

      <img class="abs halfScaleC 81-icon" style="top:552px;left:57px;" src="/2025/static/_content/81-icon-1.png"/>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:582px;left:139px; font-size: 2em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 21}' ></h1>
      <img class="abs halfScaleC 81-text" style="top:615px;left:112px;" src="/2025/static/_content/81-text-1.png"/>

      <img class="abs halfScaleC 81-icon" style="top:629px;left:65px;" src="/2025/static/_content/81-icon-2.png"/>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:645px;left:120px; font-size: 0.95em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 422}' ></h1>
      <img class="abs halfScaleC 81-text" style="top:651px;left:96px;" src="/2025/static/_content/81-text-2.png"/>

      <img class="abs halfScaleC 81-icon" style="top:632px;left:176px;" src="/2025/static/_content/81-icon-3.png"/>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:646px;left:215px; font-size: 0.95em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 82}' ></h1>
      <img class="abs halfScaleC 81-text" style="top:652px;left:186px;" src="/2025/static/_content/81-text-3.png"/>


      <!-- piechart 1 -->

      <img class="abs halfScaleC 81-pie" style="top:633px;left:10px;" src="/2025/static/_content/81-pie-1.png"/>
      <img class="abs halfScaleC 81-line" style="top:731px;left:147px;" src="/2025/static/_content/81-line-1.png"/>
      <img class="abs halfScaleC 81-pie-text" style="top:696px;left:191px;" src="/2025/static/_content/81-text-4.png"/>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:730px;left:216px; font-size: 0.95em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 91.5, "decimals" : 1, "append" : "%"}' ></h1>
 

      <!-- piechart 2 -->

      <img class="abs halfScaleC 81-pie" style="top:448px;left:220px;" src="/2025/static/_content/81-pie-2.png"/>
      <img class="abs halfScaleC 81-line" style="top:623px;left:374px;" src="/2025/static/_content/81-line-2.png"/>
      <img class="abs halfScaleC 81-line" style="top:601px;left:294px;" src="/2025/static/_content/81-line-3.png"/>
      <img class="abs halfScaleC 81-pie-text" style="top:577px;left:436px;" src="/2025/static/_content/81-text-5.png"/>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:687px;left:474px; font-size: 0.95em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 313, "append" : " -"}' ></h1>
      <h1 id="81-no" class="abs montAlternatesLt 81-no" style="top:686px;left:513px; font-size: 0.95em; font-weight: 300; color: #33b8cc; padding: 0px; margin: 0px;" data-number='{"to": 74, "append" : "%"}' ></h1>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:730px;left:474px; font-size: 0.95em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 109, "append" : " -"}' ></h1>
      <h1 id="81-no" class="abs montAlternatesLt 81-no" style="top:730px;left:516px; font-size: 0.95em; font-weight: 300; color: #b4ce47; padding: 0px; margin: 0px;" data-number='{"to": 26, "append" : "%"}' ></h1>

      <!-- icon with numbers -->

      <img class="abs halfScaleC 81-icon-no" style="top:739px;left:74px;" src="/2025/static/_content/81-icon-4.png"/>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:789px;left:257px; font-size: 1em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;" data-number='{"to": 2}' ></h1>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:789px;left:302px; font-size: 1em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;" data-number='{"to": 3}' ></h1>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:789px;left:351px; font-size: 1em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;" data-number='{"to": 3}' ></h1>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:789px;left:396px; font-size: 1em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;" data-number='{"to": 7}' ></h1>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:789px;left:437px; font-size: 1em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;" data-number='{"to": 2}' ></h1>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:789px;left:488px; font-size: 1em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;" data-number='{"to": 1}' ></h1>
      <h1 id="81-no" class="abs montAlternatesBd 81-no" style="top:789px;left:535px; font-size: 1em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;" data-number='{"to": 3}' ></h1>
      
      `,
      "script": `
        function onPageEnter() {
          pg81Anim = new TimelineMax();
          pg81Anim.fromTo(cOf("81-box"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("81-icon"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1.3)
          .fromTo(cOf("81-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[0])}}, 1.4)
          .staggerFromTo(cOf("81-text"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.4, 1.7)
          .fromTo(cOf("81-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[1])}}, 1.6)
          .fromTo(cOf("81-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[2])}}, 1.8)

          .staggerFromTo(cOf("81-pie"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.5, 2.8)
          .staggerFromTo(cOf("81-line"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.5, 3)
          .staggerFromTo(cOf("81-pie-text"), 0.5, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.5, 3.5)
          .fromTo(cOf("81-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[3])}}, 3.6)
          .fromTo(cOf("81-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[4])}}, 4.2)
          .fromTo(cOf("81-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[5])}}, 4.2)
          .fromTo(cOf("81-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[6])}}, 4.4)
          .fromTo(cOf("81-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[7])}}, 4.4)
  
          .fromTo(cOf("81-icon-no"), 0.6, {opacity:0, y: 10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 4.7)
          .fromTo(cOf("81-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[8])}}, 5)
          .fromTo(cOf("81-no")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[9])}}, 5)
          .fromTo(cOf("81-no")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[10])}}, 5)
          .fromTo(cOf("81-no")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[11])}}, 5)
          .fromTo(cOf("81-no")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[12])}}, 5)
          .fromTo(cOf("81-no")[13], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[13])}}, 5)
          .fromTo(cOf("81-no")[14], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("81-no")[14])}}, 5)
        }

        function onPageLeave() {
          pg81Anim.stop();
          resetNumbers("81-no");
        }
      `,
      "searchText": "Academies  Institutional  ACADEMY STATISTICS  21  academies  422  coaches registered  Participant coaches by gender  82  federations represented  Female coaches  Exam pass rate  Male coaches  313 - 74%  109 - 26%  91.5%  GfA  2  MAG  3  WAG  3  RG  7  T&T  2  ACRO  1  AER  3  WORLD GYMNASTICS YEARBOOK 2025  81"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 81,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg82.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:301px;left:227px;width:148px;height:12px">
          <a href="https://www.gymnastics.sport/site/pages/governance-financial.php" target="_blank"></a>
        </div>
        <div class="contentLink" style="top:312px;left:227px;width:63px;height:12px">
          <a href="https://www.gymnastics.sport/site/pages/governance-financial.php" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Institutional  Finance  Financial results Well-managed event activities contributed substantially to the improved net result and allowed further investments in development activities.  T  he gymnastics events (both competitions and institutional events or meetings) and the financial results were overall well within the budgeted limits. The combined efforts of the organising committees, the authorities, the commissions, the working groups and the World Gymnastics office  enabled the financial targets to be exceeded. Despite substantial additional investments in various areas, the latest estimation of the net result for 2025-2028 is still in line with the initially approved plan by the General Assembly in 2024. For full information, please refer to the 2025 Financial Report online.  PROFIT & LOSS STATEMENT 2025 IN THOUSANDS OF SWISS FRANCS  Actual  Budget  EVENTS + NON-CORE ACTIVITIES RESULT  8,765  9,814  OPERATIONAL EXPENSES  -9,964  -11,157  OPERATING RESULT  -1,199  -1,343  FINANCIAL RESULT  1,077  50  BUILDING RENTAL RESULT  437  420  OTHER NON-OPERATING ITEMS RESULT  2,903  3,551  NET RESULT  3,218  2,678  • Add. Gymnastics Ethics Foundation funding • Lower extraordinary income than budgeted  • Mainly unrealised profit on financial investments  • Favourable foreign currency impact • Optimised meeting expenses and HR resources • Optimised World Championship result • Lower broadcasting and sponsorship income  82  WORLD GYMNASTICS YEARBOOK 2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 82,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg83.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Finance  Institutional  BALANCE SHEET AT 31 DECEMBER 2025 IN THOUSANDS OF SWISS FRANCS  45,751  Current assets  13,571  Current liabilities  21,068  Non-current liabilities  30,874 19,762 19,762  Reserves  Non-current assets  TOTAL 65,513  TOTAL 34,639  ASSETS  LIABILITIES AND RESERVES  TOTAL 30,874  Assets  Liabilities  Reserves  • Current assets are split into cash and cash equivalent funds of CHF 12,514 as well as financial investments of CHF 29,997, which include short-term fixed deposits of CHF 3,169. All financial investments are evaluated at their market value at year-end date less a provision for potential future value adjustment of CHF 4,401. Other current assets amount to CHF 3,240. The substantial amount of cash funds is mainly related to funds in CHF to avoid any volatility risks in relation to foreign currency exchange rate variation.  • Current liabilities refer to short-term liabilities (until 31 December 2026) including pre-invoiced income and deposits for events.  • Reserves result from the accumulated profits carried forward and are a vital element to guarantee continuous support and development of our activities. Reserves are subject to fluctuation.  • Non-current liabilities reflect long-term (from 1 January 2027 onwards) liabilities such as preinvoiced income and deposits for events as well as dedicated provisions for programmes and projects.  • Non-current assets (fixed assets) are stated at their acquisition cost less the accumulated depreciation calculated over their lifetime.  WORLD GYMNASTICS YEARBOOK 2025  83"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 83,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg84.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Institutional  Finance  2% 4%  1%  3%  39%  EXPENSES SPLIT 2025 IN % OF TOTAL EXPENSES (EXCL. FINANCIAL RESULT / BUILDING RENTAL RESULT / OTHER NON-OPERATING RESULT)  9%  Events and non-core activities Staff Development incl. education Operational bodies (EC, TC, commissions) Marketing/communication General overhead  17%  Office facilities Congress/Council  25%  DEVELOPMENT AND EDUCATIONAL ACTIVITIES 2025 IN THOUSANDS OF SWISS FRANCS  3%  Development continental unions  3%  2%  41%  4%  Academies + Age Group Camps Anti-doping  4%  Equipment sponsoring Judges evaluation programme Judges educational programme  5%  Safeguarding (Unit + Commission + Symposium) Apparatus certification  TOTAL 2,878  6%  eLearning IRCOS + new development projects  15%  17% 84  WORLD GYMNASTICS YEARBOOK 2025"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 84,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg85.jpg",
      "zoom": null,
      "content": `

      <div class="contentLink" style="top:767px;left:175px;width:122px;height:18px">
        <a href="https://www.instagram.com/venturelli_aerobics/" target="_blank"></a>
      </div>

      <div class="contentLink" style="top:793px;left:67px;width:160px;height:18px">
        <a href="https://www.venturelli.com" target="_blank"></a>
      </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "TOGETHER WE PERFORM  BORN TO SUPPORT EVERY GYMNAST.  Follow us on @venturellivnt VENTURELLI.COM"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 85,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg86.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 86,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg87.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "OUTLOOK"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 87,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg88.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:277px;left:53px;width:112px;height:145px">
          <a href="https://www.glasgow2026.com/sports/gymnastics" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:466px;left:53px;width:112px;height:147px">
          <a href="https://www.ta2026.com/en/" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:668px;left:53px;width:112px;height:139px">
          <a href="https://www.aichi-nagoya2026.org/en/" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Outlook  Non-World Gymnastics events  Upcoming international gymnastics events Gymnasts around the world will have a myriad of competitions to look forward to in 2026, including the Commonwealth Games, Mediterranean Games and Asian Games.  Glasgow, Scotland 23 July - 2 August  Taranto, Italy 21 August 3 September  The ‘Friendly Games’ return to Glasgow Artistic Gymnastics is one of 10 sports in the Commonwealth Games’s pared-down programme for 2026. Happily for sports fans, the standard 14 medal events, including team and All-Around finals as well as apparatus finals for men and women will be contested in Glasgow, which last hosted the event in 2014.  Rhythmic rejoins the Mediterranean stage Seven years in the making, the 20th edition of the Mediterranean Games is at last coming to fruition in the ancient city of Taranto (ITA). With a schedule carefully tailored to avoid high summer heat and other major sporting events set in the summer months, the shoe fits perfectly in the port city located on the heel of the Italian boot.  Nagoya, Japan 19 September 4 October  Artistic and Rhythmic Gymnastics, the latter back on the programme after being left out four years ago, are among the 27 sports slated for Taranto. All 26 nations holding membership with the International Committee of Mediterranean Games are expected to take part.  Sunrise over Nagoya After Tokyo in 1958 and Hiroshima in 1994, the city of Nagoya and Japan’s Aichi prefecture have stepped forward to host the prestigious quadrennial Games of Asian nations. In Gymnastics the Asiad has unveiled new stars on their way up, although just as often they have also showcased greats in the twilight of their careers.  88  The Games are open to athletes from the 74 countries that make up the Commonwealth of Nations, bound by historic ties to Great Britain and use of English as a national language.  WORLD GYMNASTICS YEARBOOK 2025  Since Gymnastics’s debut as a medal sport in 1974, one nation has stood above the rest. The People’s Republic of China has won all but one of the team and All-Around titles in men’s Gymnastics; in the women’s events, they have never lost."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 88,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg89.jpg",
      "zoom": null,
      "content": `

       <div class="contentLink" style="top:227px;left:76px;width:137px;height:16px">
          <a href="https://rotterdam2026.com/" target="_blank"></a>
        </div>
      
        <div class="contentLink" style="top:284px;left:413px;width:147px;height:16px">
          <a href="https://www.dtb.de/" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:649px;left:75px;width:173px;height:16px">
          <a href="https://www.acropesaro2026.com/" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "World Championships 2026  Outlook  Our major events in 2026 Germany, the Netherlands, Italy, China and Spain will host five major gymnastics world championships in the months ahead. Artistic | 17-25 October 2026  Rotterdam, Netherlands Rotterdam’s Ahoy Arena will provide the stage for the 54th edition of the Artistic Worlds – the third time, after 1987 and 2010, that the event will unfold on the banks of the river Maas. For participants and spectators alike there will be plenty to catch the imagination and set pulses racing, starting with team finals on 20 October (men) and the 21st (women), followed by the All-Around  Rhythmic | 12-16 August 2026  Frankfurt, Germany  finals on the 22nd and 23rd. The championships conclude with two days of apparatus finals.  Trampoline & Tumbling | 4-8 November 2026  Nanjing, China  A dozen years after welcoming the Youth Olympic Games, Nanjing now turns toward one of gymnastics’ key Olympic disciplines. For all of China’s might in Trampoline & Tumbling, the nation has never held the World Championships, and rising levels of difficulty in the sport set the stage for historic performances from defending champions Wang Zisai and Hu Yicheng, who will be striving for a golden harvest at home.  Acrobatics | 24-27 September 2026  Pesaro, Italy  The Acrobatic Gymnastics World Championships are heading to Italy for the first time! Pesaro and its Vitrifrigo Arena will be the  setting for one of gymnastics’ most spectacular disciplines. Pesaro warmed up for this by hosting the Aerobic Gymnastics World Championships in 2024, and the city has been eager to bring gymnastics back. With more than a dozen world titles up for grabs, the seaside city gets another superb opportunity to showcase its love of the sport.  The Festhalle Messe Frankfurt will provide the stage for the 2026 edition of this global gathering of the sport’s finest – and in the process it will become the fourth German city to act as host, following Munich (1981), Berlin (1997) and Stuttgart (2015). There will be strong home interest in seeing whether Germany can repeat their successes at the 2025 Worlds, where All-Around champion Darja Varfolomeev led the way with five gold medals. This year’s All-Around final will be contested on 14 August, with apparatus finals taking place on the final day, 16 August.  Aerobics | 11-13 September 2026  Pamplona, Spain  Pamplona warmed up for the next Aerobics World Championships by bouncing through the Trampoline World Championships in 2025. In September, the city is exchanging high-flying Trampoline for heartpumping Aerobics as the fastpaced sport steps its way into new territories. Aerobics is one of the fastest growing World Gymnastics disciplines, meaning there will be plenty on hand to challenge World champion Miquel Mane (ESP) on his home turf.  WORLD GYMNASTICS YEARBOOK 2025  89"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 89,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg90.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:405px;left:439px;width:86px;height:119px;border-radius:12px">
          <a href="https://www.olympics.com/en/olympic-games/dakar-2026" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Outlook  Dakar 2026  Dakar 2026: a historic first for Africa The fourth Youth Olympic Summer Games will be the first official Olympic event on African soil.  I  n a historic moment for the Olympics, Senegal will step forward as the first African nation to host a Games of any stripe when the fourth Youth Olympics open at the end of October. Artistic Gymnastics proudly takes its place among the 25 fully genderbalanced competition sports on offer in Dakar. Off the fields of play, the Youth Olympics are renowned for providing unique educational opportunities for participants. On them, they are an intriguing  Pictured Dakar Expo Centre  90  WORLD GYMNASTICS YEARBOOK 2025  look into the crystal ball of things that may come to pass. This is especially true in Artistic Gymnastics, where a handful of Youth Olympic medallists typically ascend to the top levels of the sport and challenge for World and Olympic medals just a few years later. To date, a dozen Youth Olympic Games medallists have gone on to capture Olympic medals. Others show amazing longevity: a small number from the first Youth Olympics in 2010 are still competing as of 2026.  The Youth Olympic Games will take place from 31 October to 13 November."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 90,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg91.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:517px;left:465px;width:102px;height:104px;border-radius:50%;">
          <a href="https://www.ginastica.org/wg2027" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "World Gymnaestrada 2027 | Outlook  Looking ahead to Lisbon 2027 As Lisbon, Portugal, prepares to host the next edition of the World Gymnaestrada in 2027, preparations for the event gathered momentum in 2025.  W  ith the dust not long settled on the World Gym for Life Challenge in the same city, the first information meeting for prospective participants was held online on 18 September. The meeting was hosted by Rogerio Valerio, President of World Gymnastics’ Gymnastics for All (GFA) committee, alongside Ricardo Lima from the Local Organising Committee. To accommodate participants across different time zones, two sessions were held, providing national federations with a comprehensive overview of what to expect in Lisbon. The 2027 event will be the second edition to be staged on Portuguese soil, following the 2003 World Gymnaestrada in Lisbon. It will take place from 11-17 July next year and will be the 18th edition of a celebration of gymnastics which was first organised in Rotterdam (NED) in 1953. “Connecting the World” is the motto for Lisbon 2027 – a fitting choice given  how gymnasts from around the planet will descend on Portugal for World Gymnastics’ largest non-competitive event. It will begin and end with opening and closing ceremonies at the Restelo Stadium, with the majority of performances taking place inside two venues at the riverside Parque das Nações – the MEO Arena and FIL exhibition centre. The University Stadium Lisbon will host the large group performances. Held every four years, the World Gymnaestrada has inclusion as its central motif and as such it attracts the largest number of active participants of any World Gymnastics event with participation open to everybody, regardless of gender, age, race, religion, culture, ability or social standing. In Amsterdam (NED) in 2023, almost 20,000 gymnasts took part and the Portuguese organisers hope to surpass that figure when the Parque das Nações opens its doors to the global GfA community.  Pictured MEO Arena  WORLD GYMNASTICS YEARBOOK 2025  91"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 91,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg92.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleC 92-quote" style="top:664px;left:355px;" src="/2025/static/_content/92-quote-1.png"/>

        <div class="contentLink" style="top:265px;left:69px;width:139px;height:14px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4408723" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:627px;left:52px;width:127px;height:14px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4485363" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg92Anim = new TimelineMax();
          pg92Anim.fromTo(cOf("92-quote"), 0.6, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg92Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "News in brief  NEWS  IN BRIEF  Biles and Andrade honoured Simone Biles (USA) and Rebeca Andrade (BRA) both received accolades at the prestigious Laureus World Sports Awards in 2025. Biles was honoured as Sportswoman of the Year for the fourth time, equalling a record held by tennis star Serena Williams, while Andrade accepted the award for Comeback of the Year, owing to her continued persistence and strength in the face of injuries and setbacks.  Going strong at 50 Oksana Chusovitina (UZB) continues to push boundaries and astound gymnastics fans around the world. In June, she celebrated her 50th birthday in the midst of a World Challenge Cup in her home country’s capital of Tashkent and continued working on her goal of qualifying for the 2028 Olympic Games in Los Angeles. “My number one goal is to get to Los Angeles,” she told the Olympic Channel. “If it happens, it happens. If not, then no. But I will try, and I will give it everything I’ve got.”  92  WORLD GYMNASTICS YEARBOOK 2025  My number one goal is to get to Los Angeles. Oksana Chusovitina"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 92,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg93.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:188px;left:80px;width:61px;height:14px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4376692" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:638px;left:250px;width:95px;height:14px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4469568" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:641px;left:64px;width:107px;height:32px;">
          <a href="https://www.corpay.com/" target="_blank"></a>
        </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "News in brief  Remembering Agnes Keleti Agnes Keleti’s life embodied resilience, brilliance and a profound love for gymnastics. A Holocaust survivor and subsequent winner of 10 Olympic medals, she remains one of the most decorated gymnasts in Olympic history. She passed away in her native Budapest in January 2025, at the age of 103, and leaves behind a legacy that transcends medals – one of courage, artistry and enduring inspiration.  Corpay joins World Gymnastics family  Second IWGA award for Padilla  A global leader in business payments, Corpay became the Official World Gymnastics Global FX Exchange Payments Supplier in 2025, with the agreement effective until the end of 2028. “We are delighted about this agreement with an internationally renowned company such as Corpay,” President of World Gymnastics Morinari Watanabe declared.  Ruben Padilla (USA) made history as the first gymnast to receive the International World Games Association (IWGA) Athlete of the Month award twice. Padilla had just burst onto the scene in January 2020 when he was honoured for the first time by the organisation, and five years and four world titles later, he received the same award ahead of his participation in The World Games 2025 in Chengdu (CHN).  WORLD GYMNASTICS YEARBOOK 2025  93"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 93,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg94.jpg",
      "zoom": null,
      "content": `
      
        <div class="contentLink" style="top:705px;left:70px;width:96px;height:14px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=457253" target="_blank"></a>
        </div>

        <div class="contentLink" style="top:142px;left:379px;width:161px;height:14px;">
          <a href="https://www.gymnastics.sport/site/news/displaynews.php?urlNews=4592538" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "News in brief  Gymnastics and peace President Watanabe visited several countries in 2025, promoting peace and friendship, and emphasising the unifying power of sport. During the FIG Executive Committee meeting in Laos, President Watanabe invited one gymnast from Cambodia, Sreypov Mo, and one gymnast from Thailand, Witsawayot Saroj, to deliver a message of peace on behalf of their respective national federations, showing that sport transcends politics.  Opening doors to future sports leaders  Zanetti becomes integrity ambassador Arthur Zanetti (BRA), Still Rings champion at London 2012, has been named as one of 10 ambassadors for the International Olympic Committee’s Believe in Sport campaign. The campaign is an initiative that aims to raise awareness among athletes, their entourage members and officials about the threat of competition manipulation.  94  WORLD GYMNASTICS YEARBOOK 2025  As part of the OPEN DOORS initiative, World Gymnastics fosters constructive dialogue with students and young professionals, offering a unique opportunity to engage with a global sports federation. More than 100 participants from AISTS India, AISTS Switzerland and Université de Rouen Normandie have taken part in workshops and working groups, gaining practical experience and delivering concrete recommendations. Their contributions have helped shape ideas around brand development, fan engagement, governance and safeguarding, strengthening the federation while empowering the next generation of sports leaders."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 94,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg95.jpg",
      "zoom": null,
      "content": `
      
      <div class="contentLink" style="top:813px;left:45px;width:128px;height:18px">
        <a href="https://www.ebu.ch/sport" target="_blank"></a>
      </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "ONLY THE EBU CAN GUARANTEE SO MUCH  MULTI-PLATFORM EXPOSURE  We believe in pushing the boundaries, to finding new solutions, to doing whatever it takes to make sport a part of everyone’s life. We use the collective power of public service media organizations to showcase sport at its best. For federations, it’s an opportunity to build visibility and help their sport thrive. It’s an attitude that makes everyone a winner. www.ebu.ch/sport"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 95,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg96.jpg",
      "zoom": null,
      "content": `
      
      
      <div class="contentLink" style="top:800px;left:437px;width:128px;height:18px">
        <a href="https://www.gymnastics.sport" target="_blank"></a>
      </div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "www.gymnastics.sport"
    }]],
"script": `
    function idOf(id) {
      return document.getElementById(id)
    }

    function cOf(klass) {
      return document.getElementsByClassName(klass)
    }
    
    function removeContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) { 
        return e.className = 'addContentLink'
      })
    }

    function addContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'contentLink addContentLink'
      })
    }

    function showOverlay(idx) {
      idOf(idx).className = 'contentOverlay visible'
    }

    function hideOverlay(idx) {
      idOf(idx).className = 'contentOverlay hidden noclick'
    }

    function animateNumber(element){
      if(element.getAttribute("data-number")){
        var args = JSON.parse(element.getAttribute("data-number"));
        var from = 0;
        var to = 100;
        var append = "";
        var preppend = "";
        var decimals = 0;
        var duration = 1;
        var ease = "Linear.easeNone";
        var comma = false;
        var separator = ",";
        var decChar = ".";
        for(obj in args){
          if(obj == "from") from = args[obj];
          if(obj == "to") to = args[obj];
          if(obj == "append") append = args[obj];
          if(obj == "preppend") preppend = args[obj];
          if(obj == "decimals") decimals = args[obj];
          if(obj == "duration") duration = args[obj];
          if(obj == "ease") ease = args[obj];
          if(obj == "comma") comma = args[obj];
          if(obj == "separator") separator = args[obj];
          if(obj == "decChar") decChar = args[obj];
        }
        var obj = {number: from}
        TweenMax.to(obj, duration, {number: to, onUpdate: function(){
          if(comma){
            console.log(obj.number)
            var str = obj.number.toFixed(decimals).toString();
            var predec = str.split(/^d*/)[0];
            console.log("PREDEC", predec, typeof(predec));
            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
            var comp = newstr.replace(/^,/, '')
            console.log("NEWSTR", newstr, typeof(newstr));
            // console.log({newstr})
            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
            // if(dp[0]) dp = dp[0].replace(".", decChar);
            var dp = "";
            element.innerHTML = preppend+comp+dp+append;
          }else{
            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
          }
        }, ease: eval(ease)});
      }else{
        return;
      }
    }

    function resetNumbers(ele){
      var numbers = cOf(ele)
      for(var i=0; i<numbers.length; i++) {
        numbers[i].innerText= ""
      }
    }

    function mailChimpSubmit(){
      $('#mc-embedded-subscribe-form').submit(function (e) {
        var that = $(this);
        var mailchimpSubmit = $(this).find('input[type=submit]');
        var errorResponse = $('#mce-error-response');
        var successResponse = $('#mce-success-response');

        e.preventDefault();

        $.ajax({
          method: 'GET',
          url: that.attr('action'),
          data: that.serialize(),
          dataType: 'jsonp',
          success: function(data) {
            console.log('AJAX SUCCESS')
          // If there was an error then show the error message.
            if (data.result === 'error') {
              console.log('AJAX ERROR')
              // If the error has an error code at front then alter the message to not include the error code and hyphen.
              if(data.msg.indexOf('0') === 0) {
                data.msg = data.msg.slice(3);
              }
              errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);
            }
            // If success then show message
            else {
              successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);
            }
          }
        });
      });
    }

    function pg16_gallery(index) {
        Publish.openGalleryTwo([[
          '16-1.jpg',
          '16-2.jpg',
          '16-3.jpg',
          '16-4.jpg',
          '16-5.jpg',
          '16-6.jpg',
          '16-7.jpg',
          '16-8.jpg',
          '16-9.jpg',
          '16-10.jpg',
        ],
        index])
      }

      function pg22_gallery(index) {
        Publish.openGalleryTwo([[
          '22-1.jpg',
          '22-2.jpg',
          '22-3.jpg',
          '22-4.jpg',
          '22-5.jpg',
          '22-6.jpg',
          '22-7.jpg',
          '22-8.jpg',
          '22-9.jpg',
          '22-10.jpg',
        ],
        index])
      }

    function pg24_gallery(index) {
        Publish.openGalleryTwo([[
          '24-1.jpg',
          '24-2.jpg',
          '24-3.jpg',
          '24-4.jpg',
          '24-5.jpg',
          '24-6.jpg',
          '24-7.jpg',
          '24-8.jpg',
          '24-9.jpg',
          '24-10.jpg',
        ],
        index])
      }

    function pg26_gallery(index) {
        Publish.openGalleryTwo([[
          '26-1.jpg',
          '26-2.jpg',
          '26-3.jpg',
          '26-4.jpg',
          '26-5.jpg',
          '26-6.jpg',
          '26-7.jpg',
          '26-8.jpg',
          '26-9.jpg',
        ],
        index])
      }

    function pg32_gallery(index) {
        Publish.openGalleryTwo([[
          '32-1.jpg',
          '32-2.jpg',
          '32-3.jpg',
          '32-4.jpg',
          '32-5.jpg',
          '32-6.jpg',
          '32-7.jpg',
          '32-8.jpg',
          '32-9.jpg',
        ],
        index])
      }

    function pg34_gallery(index) {
        Publish.openGalleryTwo([[
          '34-1.jpg',
          '34-2.jpg',
          '34-3.jpg',
          '34-4.jpg',
          '34-5.jpg',
          '34-6.jpg',
        ],
        index])
      }

      function pg38_gallery(index) {
        Publish.openGalleryTwo([[
          '38-1.jpg',
          '38-2.jpg',
          '38-3.jpg',
          '38-4.jpg',
          '38-5.jpg',
          '38-6.jpg',
          '38-7.jpg',
          '38-8.jpg',
          '38-9.jpg',
          '38-10.jpg',
        ],
        index])
      }

    function pg48_gallery(index) {
        Publish.openGalleryTwo([[
          '48-1.jpg',
          '48-2.jpg',
          '48-3.jpg',
          '48-4.jpg',
          '48-5.jpg',
          '48-6.jpg',
          '48-7.jpg',
          '48-8.jpg',
          '48-9.jpg',
        ],
        index])
      }

      function pg50_gallery(index) {
        Publish.openGalleryTwo([[
          '50-1.jpg',
          '50-2.jpg',
          '50-3.jpg',
          '50-4.jpg',
          '50-5.jpg',
          '50-6.jpg',
          '50-7.jpg',
          '50-8.jpg',
          '50-9.jpg',
        ],
        index])
      }

    function pg52_gallery(index) {
        Publish.openGalleryTwo([[
          '52-1.jpg',
          '52-2.jpg',
          '52-3.jpg',
          '52-4.jpg',
          '52-5.jpg',
          '52-6.jpg',
          '52-7.jpg',
          '52-8.jpg',
          '52-9.jpg',
        ],
        index])
      }

    function pg54_gallery(index) {
        Publish.openGalleryTwo([[
          '54-1.jpg',
          '54-2.jpg',
          '54-3.jpg',
          '54-4.jpg',
          '54-5.jpg',
          '54-6.jpg',
          '54-7.jpg',
          '54-8.jpg',
          '54-9.jpg',
          '54-10.jpg',
        ],
        index])
      }

  `,
  "mobilePages": null,
  "mobileTemplate": null,
}


// WEBPACK FOOTER //
// ./src/document.js